import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import api from '../api';
import { getTagColor } from '../utils';

function Admin({ user }) {
  const teamImportRef = useRef(null);
  const history = useHistory();
  const { tab } = useParams();
  const activeTab = tab || 'events';

  const setActiveTab = (newTab) => {
    history.push(`/admin/${newTab}`);
  };
  const [events, setEvents] = useState([]);
  const [users, setUsers] = useState([]);
  const [connections, setConnections] = useState([]);
  const [twilioBalances, setTwilioBalances] = useState({});
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showConnectionForm, setShowConnectionForm] = useState(false);
  const [newEvent, setNewEvent] = useState({
    title: '',
    description: '',
    date: '',
    location: '',
    shifts: [{ name: '', start_time: '', duration_minutes: 60, helpers_needed: 5, tags: '' }]
  });
  const [newConnection, setNewConnection] = useState({
    name: 'Data-Service handball.ch',
    url: '',
    path: '/clubs/{clubId}/games',
    auth_key: '',
    oid: '',
    membership: '',
    verein_id: '',
    postal_codes: ''
  });
  const [editingConnection, setEditingConnection] = useState(null);
  const [templateShifts, setTemplateShifts] = useState([]);
  const [showTemplateForm, setShowTemplateForm] = useState(false);
  const [newTemplateShift, setNewTemplateShift] = useState({
    name: '',
    shift_type: 'per_event',
    start_offset_minutes: -15,
    end_offset_minutes: 90,
    duration_minutes: 120,
    min_duration_minutes: '',
    max_duration_minutes: '',
    helpers_needed: 2,
    tags: ''
  });
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [templateSubTab, setTemplateSubTab] = useState('event');
  const [eventTemplates, setEventTemplates] = useState([]);
  const [showEventTemplateForm, setShowEventTemplateForm] = useState(false);
  const [newEventTemplate, setNewEventTemplate] = useState({ name: '', description: '', template_shift_ids: [] });
  const [editingEventTemplate, setEditingEventTemplate] = useState(null);
  const [editingEvent, setEditingEvent] = useState(null);
  const [handballImportTemplateId, setHandballImportTemplateId] = useState('');
  const [userSearch, setUserSearch] = useState('');
  const [userSort, setUserSort] = useState({ field: 'email', direction: 'asc' });
  const [userHelferpoolFilter, setUserHelferpoolFilter] = useState([]);
  const [userTeamFilter, setUserTeamFilter] = useState([]);
  const [showTagFilter, setShowTagFilter] = useState(false);
  const [showTeamFilter, setShowTeamFilter] = useState(false);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = localStorage.getItem('adminUserColumns');
    return saved ? JSON.parse(saved) : {
      name: true,
      email: true,
      mobile: true,
      age: true,
      helferpool: true,
      team: true,
      last_login: true,
      events: true,
      admin: true,
      team_admin: true
    };
  });
  const [showNewUserForm, setShowNewUserForm] = useState(false);
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [selectedEventsForNotify, setSelectedEventsForNotify] = useState([]);
  const [notifySending, setNotifySending] = useState(false);
  const [newUser, setNewUser] = useState({
    email: '',
    first_name: '',
    last_name: '',
    mobile: '',
    date_of_birth: '',
    helferpool: '',
    team: '',
    is_admin: false
  });
  const [editingUser, setEditingUser] = useState(null);
  const [statistics, setStatistics] = useState(null);
  const [showInactiveHelpers, setShowInactiveHelpers] = useState(false);
  const [showActiveHelpers, setShowActiveHelpers] = useState(false);
  const [activeHelpersSort, setActiveHelpersSort] = useState({ field: 'shift_count', direction: 'desc' });
  const [statisticsSeasons, setStatisticsSeasons] = useState([]);
  // Import preview states
  const [fairgatePreview, setFairgatePreview] = useState(null);
  const [showFairgatePreview, setShowFairgatePreview] = useState(false);
  const [handballPreview, setHandballPreview] = useState(null);
  const [showHandballPreview, setShowHandballPreview] = useState(false);
  const [archivedEvents, setArchivedEvents] = useState([]);
  const [expandedArchiveEvent, setExpandedArchiveEvent] = useState(null);
  const [archivSubTab, setArchivSubTab] = useState('events');
  const [selectedUsers, setSelectedUsers] = useState([]);
  // Activity Log state
  const [activityLogs, setActivityLogs] = useState([]);
  const [logActions, setLogActions] = useState({});
  const [logPage, setLogPage] = useState(1);
  const [logTotal, setLogTotal] = useState(0);
  const [logPages, setLogPages] = useState(0);
  const [logFilter, setLogFilter] = useState('');
  const [logSearch, setLogSearch] = useState('');
  const [logDateFrom, setLogDateFrom] = useState('');
  const [logDateTo, setLogDateTo] = useState('');
  // Reminder settings state
  const [reminderSettings, setReminderSettings] = useState({
    enabled: false,
    days_before: 1,
    time: '09:00',
    email_fallback: false
  });
  const [reminderStatus, setReminderStatus] = useState(null);
  const [reminderPreview, setReminderPreview] = useState(null);
  const [showReminderPreview, setShowReminderPreview] = useState(false);
  // Timezone settings state
  const [timezoneSettings, setTimezoneSettings] = useState({
    timezone: 'Europe/Zurich',
    available_timezones: ['Europe/Zurich']
  });

  useEffect(() => {
    if (activeTab === 'events') {
      loadEvents();
      loadEventTemplates();
    } else if (activeTab === 'templates') {
      loadTemplateShifts();
      loadEventTemplates();
    } else if (activeTab === 'users') {
      loadUsers();
    } else if (activeTab === 'connections') {
      loadConnections();
      loadReminderSettings();
      loadTimezoneSettings();
      loadUsers(); // For Fairgate user count
      loadEventTemplates(); // For handball.ch import template selection
    } else if (activeTab === 'statistik') {
      loadStatistics();
    } else if (activeTab === 'archiv') {
      loadArchivedEvents();
      loadUsers(); // Load users for helper management
    } else if (activeTab === 'log') {
      loadActivityLogs();
    }
  }, [activeTab]);

  const loadEvents = async () => {
    setLoading(true);
    try {
      const res = await api.get('/events');
      setEvents(res.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadTemplateShifts = async () => {
    try {
      const res = await api.get('/template-shifts');
      setTemplateShifts(res.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const loadEventTemplates = async () => {
    try {
      const res = await api.get('/event-templates');
      setEventTemplates(res.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleCreateTemplateShift = async (e) => {
    e.preventDefault();
    try {
      await api.post('/template-shifts', newTemplateShift);
      setNewTemplateShift({ name: '', shift_type: 'per_event', start_offset_minutes: -15, end_offset_minutes: 90, duration_minutes: 120, min_duration_minutes: '', max_duration_minutes: '', helpers_needed: 2, tags: '' });
      setShowTemplateForm(false);
      loadTemplateShifts();
      alert('Einsatz-Vorlage erstellt!');
    } catch (error) {
      alert('Fehler beim Erstellen');
    }
  };

  const handleDeleteTemplateShift = async (id) => {
    if (window.confirm('Vorlage wirklich löschen?')) {
      try {
        await api.delete(`/template-shifts/${id}`);
        loadTemplateShifts();
      } catch (error) {
        alert('Fehler beim Löschen');
      }
    }
  };

  const handleDuplicateTemplateShift = async (id) => {
    try {
      await api.post(`/template-shifts/${id}/duplicate`);
      loadTemplateShifts();
    } catch (error) {
      alert('Fehler beim Duplizieren');
    }
  };

  const startEditTemplate = (template) => {
    setEditingTemplate({
      id: template.id,
      name: template.name,
      shift_type: template.shift_type,
      start_offset_minutes: template.start_offset_minutes,
      end_offset_minutes: template.end_offset_minutes,
      duration_minutes: template.duration_minutes,
      min_duration_minutes: template.min_duration_minutes || '',
      max_duration_minutes: template.max_duration_minutes || '',
      helpers_needed: template.helpers_needed,
      tags: template.tags || ''
    });
  };

  const handleUpdateTemplate = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/template-shifts/${editingTemplate.id}`, editingTemplate);
      setEditingTemplate(null);
      loadTemplateShifts();
      alert('Einsatz-Vorlage aktualisiert!');
    } catch (error) {
      alert('Fehler beim Aktualisieren');
    }
  };

  const handleExportTemplates = async () => {
    try {
      const response = await api.get('/template-shifts/export', {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `einsatz_vorlagen_${new Date().toISOString().slice(0, 10)}.yaml`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert('Fehler beim Export');
    }
  };

  const handleImportTemplates = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const content = await file.text();
      await api.post('/template-shifts/import', { content });
      loadTemplateShifts();
      alert('Einsatz-Vorlagen erfolgreich importiert!');
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Import');
    }

    // Reset file input
    event.target.value = '';
  };

  // Event Template handlers
  const handleCreateEventTemplate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/event-templates', newEventTemplate);
      setNewEventTemplate({ name: '', description: '', template_shift_ids: [] });
      setShowEventTemplateForm(false);
      loadEventTemplates();
      alert('Event-Vorlage erstellt!');
    } catch (error) {
      alert('Fehler beim Erstellen');
    }
  };

  const handleUpdateEventTemplate = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/event-templates/${editingEventTemplate.id}`, editingEventTemplate);
      setEditingEventTemplate(null);
      loadEventTemplates();
      alert('Event-Vorlage aktualisiert!');
    } catch (error) {
      alert('Fehler beim Aktualisieren');
    }
  };

  const handleDeleteEventTemplate = async (id) => {
    if (window.confirm('Event-Vorlage wirklich löschen?')) {
      try {
        await api.delete(`/event-templates/${id}`);
        loadEventTemplates();
      } catch (error) {
        alert('Fehler beim Löschen');
      }
    }
  };

  const handleDuplicateEventTemplate = async (id) => {
    try {
      await api.post(`/event-templates/${id}/duplicate`);
      loadEventTemplates();
    } catch (error) {
      alert('Fehler beim Duplizieren');
    }
  };

  const toggleShiftInEventTemplate = (shiftId, isEditing = false) => {
    if (isEditing) {
      const currentIds = editingEventTemplate.template_shift_ids || [];
      const newIds = currentIds.includes(shiftId)
        ? currentIds.filter(id => id !== shiftId)
        : [...currentIds, shiftId];
      setEditingEventTemplate({ ...editingEventTemplate, template_shift_ids: newIds });
    } else {
      const currentIds = newEventTemplate.template_shift_ids || [];
      const newIds = currentIds.includes(shiftId)
        ? currentIds.filter(id => id !== shiftId)
        : [...currentIds, shiftId];
      setNewEventTemplate({ ...newEventTemplate, template_shift_ids: newIds });
    }
  };

  const handleExportEventTemplates = async () => {
    try {
      const response = await api.get('/event-templates/export', {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `event_vorlagen_${new Date().toISOString().slice(0, 10)}.yaml`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      alert('Fehler beim Export');
    }
  };

  const handleImportEventTemplates = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const content = await file.text();
      await api.post('/event-templates/import', { content });
      loadEventTemplates();
      alert('Event-Vorlagen erfolgreich importiert!');
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Import');
    }

    // Reset file input
    event.target.value = '';
  };

  const loadUsers = async () => {
    setLoading(true);
    try {
      const res = await api.get('/users');
      setUsers(res.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadConnections = async () => {
    setLoading(true);
    try {
      const res = await api.get('/connections');
      setConnections(res.data);
      // Load Twilio balances for Twilio connections
      loadTwilioBalances(res.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadTwilioBalances = async (conns) => {
    const twilioConns = conns.filter(c => c.name === 'Twilio SMS API' && c.has_auth_key);
    for (const conn of twilioConns) {
      try {
        const res = await api.get(`/connections/${conn.id}/twilio-balance`);
        setTwilioBalances(prev => ({
          ...prev,
          [conn.id]: { balance: res.data.balance, currency: res.data.currency }
        }));
      } catch (error) {
        console.error(`Error loading Twilio balance for connection ${conn.id}:`, error);
        setTwilioBalances(prev => ({
          ...prev,
          [conn.id]: { error: true }
        }));
      }
    }
  };

  const loadReminderSettings = async () => {
    try {
      const res = await api.get('/settings/reminder');
      setReminderSettings(res.data);
      // Also load scheduler status
      const statusRes = await api.get('/settings/reminder/status');
      setReminderStatus(statusRes.data);
    } catch (error) {
      console.error('Error loading reminder settings:', error);
    }
  };

  const saveReminderSettings = async () => {
    try {
      await api.put('/settings/reminder', reminderSettings);
      alert('Erinnerungseinstellungen gespeichert');
      // Reload status to show updated next run time
      const statusRes = await api.get('/settings/reminder/status');
      setReminderStatus(statusRes.data);
    } catch (error) {
      alert('Fehler beim Speichern der Einstellungen');
    }
  };

  const handleSendReminders = async () => {
    // First fetch preview
    try {
      const res = await api.get('/reminders/preview');
      setReminderPreview(res.data);
      setShowReminderPreview(true);
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Laden der Vorschau');
    }
  };

  const confirmSendReminders = async () => {
    setShowReminderPreview(false);
    try {
      const res = await api.post('/reminders/send');
      alert(res.data.message);
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Senden der Erinnerungen');
    }
    setReminderPreview(null);
  };

  const loadTimezoneSettings = async () => {
    try {
      const res = await api.get('/timezone');
      setTimezoneSettings(res.data);
    } catch (error) {
      console.error('Error loading timezone settings:', error);
    }
  };

  const saveTimezoneSettings = async () => {
    try {
      await api.put('/settings/timezone', { value: timezoneSettings.timezone });
      alert('Zeitzone gespeichert');
    } catch (error) {
      alert('Fehler beim Speichern der Zeitzone');
    }
  };

  const loadStatistics = async (seasons = statisticsSeasons) => {
    setLoading(true);
    try {
      const params = seasons.length > 0 ? `?seasons=${seasons.join(',')}` : '';
      const res = await api.get(`/statistics${params}`);
      setStatistics(res.data);
    } catch (error) {
      console.error('Error loading statistics:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadArchivedEvents = async () => {
    setLoading(true);
    try {
      const res = await api.get('/events/archive');
      setArchivedEvents(res.data);
    } catch (error) {
      console.error('Error loading archived events:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadActivityLogs = async (page = logPage) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        per_page: '50'
      });
      if (logFilter) params.append('action', logFilter);
      if (logSearch) params.append('search', logSearch);
      if (logDateFrom) params.append('date_from', logDateFrom);
      if (logDateTo) params.append('date_to', logDateTo);

      const res = await api.get(`/activity-logs?${params.toString()}`);
      setActivityLogs(res.data.logs);
      setLogTotal(res.data.total);
      setLogPages(res.data.pages);
      setLogActions(res.data.actions);
      setLogPage(res.data.page);
    } catch (error) {
      console.error('Error loading activity logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogSearch = (e) => {
    e.preventDefault();
    setLogPage(1);
    loadActivityLogs(1);
  };

  const handleLogReset = () => {
    setLogFilter('');
    setLogSearch('');
    setLogDateFrom('');
    setLogDateTo('');
    setLogPage(1);
    // Load with empty filters
    setTimeout(() => loadActivityLogs(1), 0);
  };

  const startEditArchivedEvent = (event) => {
    setEditingEvent({
      id: event.id,
      title: event.title,
      description: event.description,
      date: event.date,
      location: event.location,
      shifts: event.shifts.map(s => ({
        id: s.id,
        name: s.name,
        start_time: s.start_time,
        duration_minutes: s.duration_minutes,
        helpers_needed: s.helpers_needed
      })),
      isArchived: true
    });
  };

  const handleDeleteArchivedEvent = async (id) => {
    if (window.confirm('Event wirklich löschen?')) {
      try {
        await api.delete(`/events/${id}`);
        loadArchivedEvents();
      } catch (error) {
        alert('Fehler beim Löschen');
      }
    }
  };

  const handleAddHelperToShift = async (shiftId, userId) => {
    try {
      await api.post(`/shifts/${shiftId}/signup`, { user_id: userId });
      loadArchivedEvents();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Hinzufügen');
    }
  };

  const handleRemoveHelperFromShift = async (shiftId, userId) => {
    try {
      await api.post(`/shifts/${shiftId}/signout`, { user_id: userId });
      loadArchivedEvents();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Entfernen');
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/events', newEvent);
      setNewEvent({
        title: '',
        description: '',
        date: '',
        location: '',
        shifts: [{ name: '', start_time: '', duration_minutes: 60, helpers_needed: 5, tags: '' }]
      });
      setShowForm(false);
      loadEvents();
      alert('Event erfolgreich erstellt!');
    } catch (error) {
      alert('Fehler beim Erstellen');
    }
  };

  const addShift = () => {
    setNewEvent({
      ...newEvent,
      shifts: [...newEvent.shifts, { name: '', start_time: '', duration_minutes: 60, helpers_needed: 5, tags: '' }]
    });
  };

  const removeShift = (index) => {
    const shifts = newEvent.shifts.filter((_, i) => i !== index);
    setNewEvent({ ...newEvent, shifts });
  };

  const updateShift = (index, field, value) => {
    const shifts = [...newEvent.shifts];
    shifts[index][field] = value;
    setNewEvent({ ...newEvent, shifts });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Event wirklich löschen?')) {
      try {
        await api.delete(`/events/${id}`);
        loadEvents();
      } catch (error) {
        alert('Fehler beim Löschen');
      }
    }
  };

  const handleApplyEventTemplate = async (eventId, templateId) => {
    if (!templateId) return;

    const template = eventTemplates.find(t => t.id === parseInt(templateId));
    if (!template) return;

    if (!window.confirm(`Event-Vorlage "${template.name}" anwenden? Bestehende Einsätze ohne Helfer werden gelöscht.`)) {
      return;
    }

    try {
      const res = await api.post(`/events/${eventId}/apply-template/${templateId}`);
      alert(res.data.message);
      loadEvents();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Anwenden der Vorlage');
    }
  };

  const handleDeleteGame = async (gameId) => {
    if (window.confirm('Spiel wirklich löschen? Zugehörige Einsätze bleiben erhalten, verlieren aber die Spielverknüpfung.')) {
      try {
        await api.delete(`/games/${gameId}`);
        loadEvents();
      } catch (error) {
        alert(error.response?.data?.message || 'Fehler beim Löschen');
      }
    }
  };

  const handleDeleteAllEvents = async () => {
    if (events.length === 0) {
      alert('Keine Events vorhanden.');
      return;
    }
    if (window.confirm(`Wirklich ALLE ${events.length} Events löschen?\n\nDiese Aktion kann nicht rückgängig gemacht werden!`)) {
      if (window.confirm('Sind Sie sicher? Alle Helfer-Anmeldungen gehen verloren!')) {
        try {
          const res = await api.delete('/events');
          loadEvents();
          alert(res.data.message);
        } catch (error) {
          alert('Fehler beim Löschen');
        }
      }
    }
  };

  const startEditEvent = async (eventId) => {
    try {
      const res = await api.get(`/events/${eventId}`);
      const event = res.data;
      setEditingEvent({
        id: event.id,
        title: event.title,
        description: event.description,
        date: event.date,
        location: event.location,
        shifts: event.shifts.map(s => ({
          id: s.id,
          name: s.name,
          start_time: s.start_time,
          duration_minutes: s.duration_minutes,
          helpers_needed: s.helpers_needed,
          tags: s.tags || ''
        }))
      });
    } catch (error) {
      alert('Fehler beim Laden des Events');
    }
  };

  const handleUpdateEvent = async (e) => {
    e.preventDefault();
    try {
      const isArchived = editingEvent.isArchived;
      await api.put(`/events/${editingEvent.id}`, editingEvent);
      setEditingEvent(null);
      if (isArchived) {
        loadArchivedEvents();
      } else {
        loadEvents();
      }
      alert('Event aktualisiert!');
    } catch (error) {
      alert('Fehler beim Aktualisieren');
    }
  };

  const addEditShift = () => {
    setEditingEvent({
      ...editingEvent,
      shifts: [...editingEvent.shifts, { name: '', start_time: '', duration_minutes: 60, helpers_needed: 5, tags: '' }]
    });
  };

  const removeEditShift = (index) => {
    const shifts = editingEvent.shifts.filter((_, i) => i !== index);
    setEditingEvent({ ...editingEvent, shifts });
  };

  const updateEditShift = (index, field, value) => {
    const shifts = [...editingEvent.shifts];
    shifts[index][field] = value;
    setEditingEvent({ ...editingEvent, shifts });
  };

  const handleExportCSV = async () => {
    try {
      const response = await api.get('/events/export', {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `events_export_${new Date().toISOString().slice(0, 10)}.csv`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert('Fehler beim Export');
    }
  };

  const handleExportEventsYaml = async () => {
    try {
      const response = await api.get('/events/export-yaml', {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `events_${new Date().toISOString().slice(0, 10)}.yaml`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert('Fehler beim YAML-Export');
    }
  };

  const handleImportEventsYaml = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await api.post('/events/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(res.data.message);
      loadEvents();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Import');
    }

    e.target.value = '';
  };

  const handleSendNotification = async (sendToAll) => {
    if (selectedEventsForNotify.length === 0) {
      alert('Bitte wähle mindestens ein Event aus');
      return;
    }

    const confirmMsg = sendToAll
      ? `Benachrichtigung über ${selectedEventsForNotify.length} Event(s) an ALLE Benutzer senden?`
      : `Test-E-Mail an deine eigene Adresse senden?`;

    if (!window.confirm(confirmMsg)) return;

    setNotifySending(true);
    try {
      const res = await api.post('/events/notify', {
        event_ids: selectedEventsForNotify,
        send_to_all: sendToAll
      });
      alert(res.data.message);
      setShowNotifyModal(false);
      setSelectedEventsForNotify([]);
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Senden');
    } finally {
      setNotifySending(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const renderEvents = () => {
    if (loading) return <div>Lädt...</div>;

    return (
      <>
        <div className="card" style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
          <h3 style={{ margin: 0 }}>Neues Event erstellen</h3>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            <button className="btn" onClick={handleExportCSV}>
              CSV Export
            </button>
            <button className="btn" onClick={handleExportEventsYaml}>
              YAML Export
            </button>
            <label className="btn" style={{ cursor: 'pointer', margin: 0 }}>
              YAML Import
              <input
                type="file"
                accept=".yaml,.yml"
                onChange={handleImportEventsYaml}
                style={{ display: 'none' }}
              />
            </label>
            <button className="btn" style={{ backgroundColor: '#2196f3' }} onClick={() => setShowNotifyModal(true)}>
              Benutzer informieren
            </button>
            <button className="btn btn-danger" onClick={handleDeleteAllEvents}>
              Alle löschen
            </button>
            <button className="btn" onClick={() => setShowForm(!showForm)}>
              {showForm ? 'Abbrechen' : '+ Event hinzufügen'}
            </button>
          </div>
        </div>

        {showForm && (
          <form onSubmit={handleCreate} style={{ marginTop: '1.5rem' }}>
            <label>Titel</label>
            <input
              type="text"
              value={newEvent.title}
              onChange={(e) => setNewEvent({...newEvent, title: e.target.value})}
              placeholder="z.B. Heimspiel gegen Team X"
              required
            />

            <label>Beschreibung</label>
            <textarea
              value={newEvent.description}
              onChange={(e) => setNewEvent({...newEvent, description: e.target.value})}
              placeholder="Details zum Event..."
              rows="4"
              required
            />

            <label>Datum</label>
            <input
              type="date"
              value={newEvent.date}
              onChange={(e) => setNewEvent({...newEvent, date: e.target.value})}
              required
            />

            <label>Ort</label>
            <input
              type="text"
              value={newEvent.location}
              onChange={(e) => setNewEvent({...newEvent, location: e.target.value})}
              placeholder="z.B. Sporthalle Musterhausen"
              required
            />

            <div style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <label style={{ margin: 0 }}>Helfereinsätze</label>
                <button type="button" onClick={addShift} className="btn" style={{ padding: '0.5rem 1rem' }}>
                  + Einsatz hinzufügen
                </button>
              </div>

              {newEvent.shifts.map((shift, index) => (
                <div key={index} style={{
                  padding: '1rem',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  marginBottom: '1rem'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                    <strong>Einsatz {index + 1}</strong>
                    {newEvent.shifts.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeShift(index)}
                        className="btn btn-danger"
                        style={{ padding: '0.25rem 0.75rem' }}
                      >
                        Entfernen
                      </button>
                    )}
                  </div>

                  <label>Name des Einsatzes</label>
                  <input
                    type="text"
                    value={shift.name}
                    onChange={(e) => updateShift(index, 'name', e.target.value)}
                    placeholder="z.B. Aufbau, Verkauf, Abbau"
                    required
                  />

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <div>
                      <label>Startzeit</label>
                      <input
                        type="time"
                        value={shift.start_time}
                        onChange={(e) => updateShift(index, 'start_time', e.target.value)}
                        required
                      />
                    </div>
                    <div>
                      <label>Dauer (Minuten)</label>
                      <input
                        type="number"
                        min="15"
                        step="15"
                        value={shift.duration_minutes}
                        onChange={(e) => updateShift(index, 'duration_minutes', parseInt(e.target.value))}
                        required
                      />
                    </div>
                  </div>

                  <label>Benötigte Helfer</label>
                  <input
                    type="number"
                    min="1"
                    value={shift.helpers_needed}
                    onChange={(e) => updateShift(index, 'helpers_needed', parseInt(e.target.value))}
                    required
                  />

                  <label>Tags (Semikolon-getrennt)</label>
                  <input
                    type="text"
                    value={shift.tags || ''}
                    onChange={(e) => updateShift(index, 'tags', e.target.value)}
                    placeholder="z.B. Bar; Kiosk"
                  />
                </div>
              ))}
            </div>

            <button type="submit" className="btn" style={{ marginTop: '0.5rem' }}>
              Event erstellen
            </button>
          </form>
        )}
      </div>

      <div className="card">
        <h3 style={{ marginBottom: '1rem' }}>Alle Events ({events.length})</h3>
        {events.length === 0 ? (
          <p style={{ color: '#666' }}>Noch keine Events vorhanden.</p>
        ) : (
          <div>
            {events.map(event => (
              <div key={event.id} style={{
                padding: '1rem',
                backgroundColor: '#f5f5f5',
                borderRadius: '4px',
                marginBottom: '0.5rem'
              }}>
                {editingEvent && editingEvent.id === event.id ? (
                  /* Edit Form */
                  <form onSubmit={handleUpdateEvent}>
                    <label>Titel</label>
                    <input
                      type="text"
                      value={editingEvent.title}
                      onChange={(e) => setEditingEvent({...editingEvent, title: e.target.value})}
                      required
                    />

                    <label>Beschreibung</label>
                    <textarea
                      value={editingEvent.description}
                      onChange={(e) => setEditingEvent({...editingEvent, description: e.target.value})}
                      rows="3"
                      required
                    />

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div>
                        <label>Datum</label>
                        <input
                          type="date"
                          value={editingEvent.date}
                          onChange={(e) => setEditingEvent({...editingEvent, date: e.target.value})}
                          required
                        />
                      </div>
                      <div>
                        <label>Ort</label>
                        <input
                          type="text"
                          value={editingEvent.location}
                          onChange={(e) => setEditingEvent({...editingEvent, location: e.target.value})}
                          required
                        />
                      </div>
                    </div>

                    <div style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                        <label style={{ margin: 0 }}>Helfereinsätze</label>
                        <button type="button" onClick={addEditShift} className="btn" style={{ padding: '0.5rem 1rem' }}>
                          + Einsatz hinzufügen
                        </button>
                      </div>

                      {editingEvent.shifts.map((shift, index) => (
                        <div key={shift.id || `new-${index}`} style={{
                          padding: '1rem',
                          backgroundColor: '#fff',
                          borderRadius: '4px',
                          marginBottom: '0.5rem',
                          border: '1px solid #ddd'
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                            <strong>Einsatz {index + 1}</strong>
                            {editingEvent.shifts.length > 1 && (
                              <button
                                type="button"
                                onClick={() => removeEditShift(index)}
                                className="btn btn-danger"
                                style={{ padding: '0.25rem 0.75rem' }}
                              >
                                Entfernen
                              </button>
                            )}
                          </div>

                          <label>Name des Einsatzes</label>
                          <input
                            type="text"
                            value={shift.name}
                            onChange={(e) => updateEditShift(index, 'name', e.target.value)}
                            required
                          />

                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div>
                              <label>Startzeit</label>
                              <input
                                type="time"
                                value={shift.start_time}
                                onChange={(e) => updateEditShift(index, 'start_time', e.target.value)}
                                required
                              />
                            </div>
                            <div>
                              <label>Dauer (Minuten)</label>
                              <input
                                type="number"
                                min="15"
                                step="15"
                                value={shift.duration_minutes}
                                onChange={(e) => updateEditShift(index, 'duration_minutes', parseInt(e.target.value))}
                                required
                              />
                            </div>
                          </div>

                          <label>Benötigte Helfer</label>
                          <input
                            type="number"
                            min="1"
                            value={shift.helpers_needed}
                            onChange={(e) => updateEditShift(index, 'helpers_needed', parseInt(e.target.value))}
                            required
                          />

                          <label>Tags (Semikolon-getrennt)</label>
                          <input
                            type="text"
                            value={shift.tags || ''}
                            onChange={(e) => updateEditShift(index, 'tags', e.target.value)}
                            placeholder="z.B. Bar; Kiosk"
                          />
                        </div>
                      ))}
                    </div>

                    <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
                      <button type="submit" className="btn">
                        Speichern
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setEditingEvent(null)}
                      >
                        Abbrechen
                      </button>
                    </div>
                  </form>
                ) : (
                  /* Display Mode */
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ flex: 1 }}>
                        <Link to={`/event/${event.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                          <strong>{event.title}</strong>
                          <div style={{ color: '#666', fontSize: '0.9rem', marginTop: '0.25rem' }}>
                            {formatDate(event.date)} • {event.location}
                          </div>
                          <div style={{ color: '#888', fontSize: '0.85rem', marginTop: '0.25rem' }}>
                            {event.shifts?.length || 0} Einsätze
                            {event.games?.length > 0 && ` • ${event.games.length} Spiele`}
                          </div>
                        </Link>
                      </div>
                      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                        <span style={{
                          padding: '0.25rem 0.75rem',
                          backgroundColor: '#e0e0e0',
                          borderRadius: '4px',
                          fontSize: '0.9rem'
                        }}>
                          {event.shifts?.reduce((sum, s) => sum + (s.helpers_count || 0), 0)}/
                          {event.shifts?.reduce((sum, s) => sum + s.helpers_needed, 0)} Helfer
                        </span>
                        {eventTemplates.length > 0 && (
                          <select
                            onChange={(e) => handleApplyEventTemplate(event.id, e.target.value)}
                            value=""
                            style={{
                              padding: '0.5rem',
                              borderRadius: '4px',
                              border: '1px solid #ddd',
                              fontSize: '0.9rem',
                              cursor: 'pointer'
                            }}
                          >
                            <option value="">Vorlage anwenden...</option>
                            {eventTemplates.map(template => (
                              <option key={template.id} value={template.id}>
                                {template.name}
                              </option>
                            ))}
                          </select>
                        )}
                        <button
                          onClick={() => startEditEvent(event.id)}
                          className="btn"
                          style={{ padding: '0.5rem 1rem' }}
                        >
                          Bearbeiten
                        </button>
                        <button
                          onClick={() => handleDelete(event.id)}
                          className="btn btn-danger"
                          style={{ padding: '0.5rem 1rem' }}
                        >
                          Löschen
                        </button>
                      </div>
                    </div>
                    {event.games && event.games.length > 0 && (
                      <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem', borderTop: '1px solid #e0e0e0' }}>
                        <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.5rem' }}>Spiele:</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                          {event.games.map((game) => (
                            <div key={game.id} style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '0.5rem',
                              backgroundColor: '#fff',
                              borderRadius: '4px',
                              fontSize: '0.85rem'
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{ fontWeight: 'bold', minWidth: '45px' }}>{game.game_time}</span>
                                {game.league_short && (
                                  <span style={{
                                    padding: '0.1rem 0.4rem',
                                    backgroundColor: '#e3f2fd',
                                    borderRadius: '4px',
                                    fontSize: '0.75rem'
                                  }}>
                                    {game.league_short}
                                  </span>
                                )}
                                <span>{game.team_a} vs {game.team_b}</span>
                              </div>
                              <button
                                onClick={() => handleDeleteGame(game.id)}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  color: '#c62828',
                                  cursor: 'pointer',
                                  fontSize: '0.9rem',
                                  padding: '0.25rem 0.5rem'
                                }}
                                title="Spiel löschen"
                              >
                                ✕
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Notification Modal */}
      {showNotifyModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="card" style={{
            maxWidth: '500px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            margin: '1rem'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ margin: 0 }}>Benutzer über neue Events informieren</h3>
              <button
                onClick={() => { setShowNotifyModal(false); setSelectedEventsForNotify([]); }}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666' }}
              >
                ×
              </button>
            </div>

            <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem' }}>
              Wähle die Events aus, über die informiert werden soll:
            </p>

            <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '1rem' }}>
              {events.filter(e => new Date(e.date) >= new Date().setHours(0,0,0,0)).length === 0 ? (
                <p style={{ padding: '1rem', color: '#666', textAlign: 'center' }}>Keine anstehenden Events vorhanden</p>
              ) : (
                events
                  .filter(e => new Date(e.date) >= new Date().setHours(0,0,0,0))
                  .sort((a, b) => new Date(a.date) - new Date(b.date))
                  .map(event => (
                    <label key={event.id} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '0.75rem',
                      borderBottom: '1px solid #eee',
                      cursor: 'pointer',
                      backgroundColor: selectedEventsForNotify.includes(event.id) ? '#e3f2fd' : 'transparent'
                    }}>
                      <input
                        type="checkbox"
                        checked={selectedEventsForNotify.includes(event.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedEventsForNotify([...selectedEventsForNotify, event.id]);
                          } else {
                            setSelectedEventsForNotify(selectedEventsForNotify.filter(id => id !== event.id));
                          }
                        }}
                      />
                      <div>
                        <div style={{ fontWeight: 'bold' }}>{event.title}</div>
                        <div style={{ fontSize: '0.85rem', color: '#666' }}>
                          {formatDate(event.date)} • {event.location}
                        </div>
                      </div>
                    </label>
                  ))
              )}
            </div>

            {selectedEventsForNotify.length > 0 && (
              <p style={{ fontSize: '0.9rem', color: '#1565c0', marginBottom: '1rem' }}>
                {selectedEventsForNotify.length} Event(s) ausgewählt
              </p>
            )}

            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <button
                className="btn"
                onClick={() => handleSendNotification(false)}
                disabled={notifySending || selectedEventsForNotify.length === 0}
                style={{ backgroundColor: '#666' }}
              >
                {notifySending ? 'Sende...' : 'Test an mich'}
              </button>
              <button
                className="btn"
                onClick={() => handleSendNotification(true)}
                disabled={notifySending || selectedEventsForNotify.length === 0}
                style={{ backgroundColor: '#4caf50' }}
              >
                {notifySending ? 'Sende...' : 'An alle Benutzer senden'}
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => { setShowNotifyModal(false); setSelectedEventsForNotify([]); }}
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}
      </>
    );
  };


  const renderTemplates = () => {
    return (
      <>
        {/* Subtab Navigation */}
        <div style={{
          display: 'flex',
          gap: '0.5rem',
          marginBottom: '1.5rem',
          borderBottom: '1px solid #e0e0e0',
          paddingBottom: '0.5rem'
        }}>
          <button
            onClick={() => setTemplateSubTab('event')}
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              background: templateSubTab === 'event' ? '#f5f5f5' : 'transparent',
              color: templateSubTab === 'event' ? '#C62828' : '#666',
              borderBottom: templateSubTab === 'event' ? '2px solid #C62828' : '2px solid transparent',
              cursor: 'pointer',
              fontWeight: templateSubTab === 'event' ? 'bold' : 'normal',
              fontSize: '0.95rem',
              transition: 'all 0.2s',
              borderRadius: '4px 4px 0 0'
            }}
          >
            Event-Vorlagen
          </button>
          <button
            onClick={() => setTemplateSubTab('einsatz')}
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              background: templateSubTab === 'einsatz' ? '#f5f5f5' : 'transparent',
              color: templateSubTab === 'einsatz' ? '#C62828' : '#666',
              borderBottom: templateSubTab === 'einsatz' ? '2px solid #C62828' : '2px solid transparent',
              cursor: 'pointer',
              fontWeight: templateSubTab === 'einsatz' ? 'bold' : 'normal',
              fontSize: '0.95rem',
              transition: 'all 0.2s',
              borderRadius: '4px 4px 0 0'
            }}
          >
            Einsatz-Vorlagen
          </button>
        </div>

        {templateSubTab === 'einsatz' && (
        <>
        <div className="card" style={{ marginBottom: '2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h3 style={{ margin: 0 }}>Neue Einsatz-Vorlage erstellen</h3>
              <p style={{ margin: '0.5rem 0 0 0', color: '#666', fontSize: '0.9rem' }}>
                Vorlagen werden beim Import von Spielen verwendet.
              </p>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <button className="btn" onClick={handleExportTemplates}>
                YAML Export
              </button>
              <label className="btn" style={{ cursor: 'pointer', margin: 0 }}>
                YAML Import
                <input
                  type="file"
                  accept=".yaml,.yml"
                  onChange={handleImportTemplates}
                  style={{ display: 'none' }}
                />
              </label>
              <button className="btn" onClick={() => setShowTemplateForm(!showTemplateForm)}>
                {showTemplateForm ? 'Abbrechen' : '+ Vorlage hinzufügen'}
              </button>
            </div>
          </div>

          {showTemplateForm && (
            <form onSubmit={handleCreateTemplateShift} style={{ marginTop: '1.5rem' }}>
              <label>Name des Einsatzes</label>
              <input
                type="text"
                value={newTemplateShift.name}
                onChange={(e) => setNewTemplateShift({...newTemplateShift, name: e.target.value})}
                placeholder="z.B. Zeitnehmer, Liveticker, Kasse"
                required
              />

              <label style={{ marginTop: '1rem' }}>Einsatztyp</label>
              <select
                value={newTemplateShift.shift_type}
                onChange={(e) => setNewTemplateShift({...newTemplateShift, shift_type: e.target.value})}
                style={{ padding: '0.75rem', width: '100%', marginBottom: '1rem', borderRadius: '4px', border: '1px solid #ddd' }}
                required
              >
                <option value="per_event">Pro Event (aufgeteilt in mehrere Einsätze)</option>
                <option value="per_game">Pro Spiel (ein Einsatz je Spiel)</option>
                <option value="aufbau">Aufbau (ein Einsatz vor 1. Spiel)</option>
                <option value="abbau">Abbau (ein Einsatz nach letztem Spiel)</option>
              </select>

              {newTemplateShift.shift_type === 'per_event' && (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <div>
                      <label>Start (Offset zum 1. Spiel)</label>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                          type="number"
                          value={newTemplateShift.start_offset_minutes}
                          onChange={(e) => setNewTemplateShift({...newTemplateShift, start_offset_minutes: parseInt(e.target.value)})}
                          style={{ width: '80px' }}
                          required
                        />
                        <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                      </div>
                      <span style={{ color: '#888', fontSize: '0.8rem' }}>
                        {newTemplateShift.start_offset_minutes < 0
                          ? `${Math.abs(newTemplateShift.start_offset_minutes)} Min. vor 1. Spiel`
                          : newTemplateShift.start_offset_minutes > 0
                            ? `${newTemplateShift.start_offset_minutes} Min. nach 1. Spiel`
                            : 'Bei Spielbeginn 1. Spiel'}
                      </span>
                    </div>
                    <div>
                      <label>Ende (Offset zum letzten Spiel)</label>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                          type="number"
                          value={newTemplateShift.end_offset_minutes}
                          onChange={(e) => setNewTemplateShift({...newTemplateShift, end_offset_minutes: parseInt(e.target.value)})}
                          style={{ width: '80px' }}
                          required
                        />
                        <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                      </div>
                      <span style={{ color: '#888', fontSize: '0.8rem' }}>
                        {newTemplateShift.end_offset_minutes > 0
                          ? `${newTemplateShift.end_offset_minutes} Min. nach letztem Spiel`
                          : newTemplateShift.end_offset_minutes < 0
                            ? `${Math.abs(newTemplateShift.end_offset_minutes)} Min. vor letztem Spiel`
                            : 'Bei Spielbeginn letztes Spiel'}
                      </span>
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                    <div>
                      <label>Bevorzugte Dauer (Minuten)</label>
                      <input
                        type="number"
                        min="15"
                        step="15"
                        value={newTemplateShift.duration_minutes}
                        onChange={(e) => setNewTemplateShift({...newTemplateShift, duration_minutes: parseInt(e.target.value)})}
                        required
                      />
                    </div>
                    <div>
                      <label>Benötigte Helfer</label>
                      <input
                        type="number"
                        min="1"
                        value={newTemplateShift.helpers_needed}
                        onChange={(e) => setNewTemplateShift({...newTemplateShift, helpers_needed: parseInt(e.target.value)})}
                        required
                      />
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                    <div>
                      <label>Mindestdauer (Minuten)</label>
                      <input
                        type="number"
                        min="15"
                        step="15"
                        value={newTemplateShift.min_duration_minutes}
                        onChange={(e) => setNewTemplateShift({...newTemplateShift, min_duration_minutes: e.target.value ? parseInt(e.target.value) : ''})}
                        placeholder="Optional"
                      />
                    </div>
                    <div>
                      <label>Maximaldauer (Minuten)</label>
                      <input
                        type="number"
                        min="15"
                        step="15"
                        value={newTemplateShift.max_duration_minutes}
                        onChange={(e) => setNewTemplateShift({...newTemplateShift, max_duration_minutes: e.target.value ? parseInt(e.target.value) : ''})}
                        placeholder="Optional"
                      />
                    </div>
                  </div>
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>
                    Bei Min/Max-Dauer wird die Einsatzdauer optimal verteilt, sodass alle Einsätze im angegebenen Bereich liegen.
                  </p>
                </>
              )}

              {newTemplateShift.shift_type === 'per_game' && (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <div>
                      <label>Start (Offset zum Spielbeginn)</label>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                          type="number"
                          value={newTemplateShift.start_offset_minutes}
                          onChange={(e) => setNewTemplateShift({...newTemplateShift, start_offset_minutes: parseInt(e.target.value)})}
                          style={{ width: '80px' }}
                          required
                        />
                        <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                      </div>
                      <span style={{ color: '#888', fontSize: '0.8rem' }}>
                        {newTemplateShift.start_offset_minutes < 0
                          ? `${Math.abs(newTemplateShift.start_offset_minutes)} Min. vor Spielbeginn`
                          : newTemplateShift.start_offset_minutes > 0
                            ? `${newTemplateShift.start_offset_minutes} Min. nach Spielbeginn`
                            : 'Bei Spielbeginn'}
                      </span>
                    </div>
                    <div>
                      <label>Dauer (Minuten)</label>
                      <input
                        type="number"
                        min="15"
                        step="15"
                        value={newTemplateShift.duration_minutes}
                        onChange={(e) => setNewTemplateShift({...newTemplateShift, duration_minutes: parseInt(e.target.value)})}
                        required
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    <label>Benötigte Helfer</label>
                    <input
                      type="number"
                      min="1"
                      value={newTemplateShift.helpers_needed}
                      onChange={(e) => setNewTemplateShift({...newTemplateShift, helpers_needed: parseInt(e.target.value)})}
                      style={{ width: '100px' }}
                      required
                    />
                  </div>
                </>
              )}

              {newTemplateShift.shift_type === 'aufbau' && (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <div>
                      <label>Start (Offset zum 1. Spiel)</label>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                          type="number"
                          value={newTemplateShift.start_offset_minutes}
                          onChange={(e) => setNewTemplateShift({...newTemplateShift, start_offset_minutes: parseInt(e.target.value)})}
                          style={{ width: '80px' }}
                          required
                        />
                        <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                      </div>
                      <span style={{ color: '#888', fontSize: '0.8rem' }}>
                        {newTemplateShift.start_offset_minutes < 0
                          ? `${Math.abs(newTemplateShift.start_offset_minutes)} Min. vor 1. Spiel`
                          : newTemplateShift.start_offset_minutes > 0
                            ? `${newTemplateShift.start_offset_minutes} Min. nach 1. Spiel`
                            : 'Bei Spielbeginn 1. Spiel'}
                      </span>
                    </div>
                    <div>
                      <label>Dauer (Minuten)</label>
                      <input
                        type="number"
                        min="15"
                        step="15"
                        value={newTemplateShift.duration_minutes}
                        onChange={(e) => setNewTemplateShift({...newTemplateShift, duration_minutes: parseInt(e.target.value)})}
                        required
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    <label>Benötigte Helfer</label>
                    <input
                      type="number"
                      min="1"
                      value={newTemplateShift.helpers_needed}
                      onChange={(e) => setNewTemplateShift({...newTemplateShift, helpers_needed: parseInt(e.target.value)})}
                      style={{ width: '100px' }}
                      required
                    />
                  </div>
                </>
              )}

              {newTemplateShift.shift_type === 'abbau' && (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    <div>
                      <label>Start (Offset zum letzten Spiel)</label>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                          type="number"
                          value={newTemplateShift.start_offset_minutes}
                          onChange={(e) => setNewTemplateShift({...newTemplateShift, start_offset_minutes: parseInt(e.target.value)})}
                          style={{ width: '80px' }}
                          required
                        />
                        <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                      </div>
                      <span style={{ color: '#888', fontSize: '0.8rem' }}>
                        {newTemplateShift.start_offset_minutes > 0
                          ? `${newTemplateShift.start_offset_minutes} Min. nach letztem Spiel`
                          : newTemplateShift.start_offset_minutes < 0
                            ? `${Math.abs(newTemplateShift.start_offset_minutes)} Min. vor letztem Spiel`
                            : 'Bei Spielbeginn letztes Spiel'}
                      </span>
                    </div>
                    <div>
                      <label>Dauer (Minuten)</label>
                      <input
                        type="number"
                        min="15"
                        step="15"
                        value={newTemplateShift.duration_minutes}
                        onChange={(e) => setNewTemplateShift({...newTemplateShift, duration_minutes: parseInt(e.target.value)})}
                        required
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    <label>Benötigte Helfer</label>
                    <input
                      type="number"
                      min="1"
                      value={newTemplateShift.helpers_needed}
                      onChange={(e) => setNewTemplateShift({...newTemplateShift, helpers_needed: parseInt(e.target.value)})}
                      style={{ width: '100px' }}
                      required
                    />
                  </div>
                </>
              )}

              <div style={{ marginTop: '1rem' }}>
                <label>Tags (Semikolon-getrennt)</label>
                <input
                  type="text"
                  value={newTemplateShift.tags}
                  onChange={(e) => setNewTemplateShift({...newTemplateShift, tags: e.target.value})}
                  placeholder="z.B. Bar; Kiosk; Turnhalle"
                  style={{ width: '100%' }}
                />
                <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '0.25rem' }}>
                  Tags werden auf Einsätze übertragen, die aus dieser Vorlage erstellt werden.
                </div>
              </div>

              <button type="submit" className="btn" style={{ marginTop: '1rem' }}>
                Vorlage erstellen
              </button>
            </form>
          )}
        </div>

        <div className="card">
          <h3 style={{ marginBottom: '1rem' }}>Alle Einsatz-Vorlagen ({templateShifts.length})</h3>
          {templateShifts.length === 0 ? (
            <p style={{ color: '#666' }}>Noch keine Einsatz-Vorlagen definiert.</p>
          ) : (
            <div>
              {templateShifts.map((template) => (
                <div key={template.id} style={{
                  padding: '1rem',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  marginBottom: '0.5rem'
                }}>
                  {editingTemplate && editingTemplate.id === template.id ? (
                    /* Edit Form */
                    <form onSubmit={handleUpdateTemplate}>
                      <label>Name des Einsatzes</label>
                      <input
                        type="text"
                        value={editingTemplate.name}
                        onChange={(e) => setEditingTemplate({...editingTemplate, name: e.target.value})}
                        required
                      />

                      <label style={{ marginTop: '1rem' }}>Einsatztyp</label>
                      <select
                        value={editingTemplate.shift_type}
                        onChange={(e) => setEditingTemplate({...editingTemplate, shift_type: e.target.value})}
                        style={{ padding: '0.75rem', width: '100%', marginBottom: '1rem', borderRadius: '4px', border: '1px solid #ddd' }}
                        required
                      >
                        <option value="per_event">Pro Event (aufgeteilt in mehrere Einsätze)</option>
                        <option value="per_game">Pro Spiel (ein Einsatz je Spiel)</option>
                        <option value="aufbau">Aufbau (ein Einsatz vor 1. Spiel)</option>
                        <option value="abbau">Abbau (ein Einsatz nach letztem Spiel)</option>
                      </select>

                      {editingTemplate.shift_type === 'per_event' && (
                        <>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div>
                              <label>Start (Offset zum 1. Spiel)</label>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <input
                                  type="number"
                                  value={editingTemplate.start_offset_minutes}
                                  onChange={(e) => setEditingTemplate({...editingTemplate, start_offset_minutes: parseInt(e.target.value)})}
                                  style={{ width: '80px' }}
                                  required
                                />
                                <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                              </div>
                            </div>
                            <div>
                              <label>Ende (Offset zum letzten Spiel)</label>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <input
                                  type="number"
                                  value={editingTemplate.end_offset_minutes}
                                  onChange={(e) => setEditingTemplate({...editingTemplate, end_offset_minutes: parseInt(e.target.value)})}
                                  style={{ width: '80px' }}
                                  required
                                />
                                <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                              </div>
                            </div>
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                            <div>
                              <label>Bevorzugte Dauer (Minuten)</label>
                              <input
                                type="number"
                                min="15"
                                step="15"
                                value={editingTemplate.duration_minutes}
                                onChange={(e) => setEditingTemplate({...editingTemplate, duration_minutes: parseInt(e.target.value)})}
                                required
                              />
                            </div>
                            <div>
                              <label>Benötigte Helfer</label>
                              <input
                                type="number"
                                min="1"
                                value={editingTemplate.helpers_needed}
                                onChange={(e) => setEditingTemplate({...editingTemplate, helpers_needed: parseInt(e.target.value)})}
                                required
                              />
                            </div>
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                            <div>
                              <label>Mindestdauer (Minuten)</label>
                              <input
                                type="number"
                                min="15"
                                step="15"
                                value={editingTemplate.min_duration_minutes}
                                onChange={(e) => setEditingTemplate({...editingTemplate, min_duration_minutes: e.target.value ? parseInt(e.target.value) : ''})}
                                placeholder="Optional"
                              />
                            </div>
                            <div>
                              <label>Maximaldauer (Minuten)</label>
                              <input
                                type="number"
                                min="15"
                                step="15"
                                value={editingTemplate.max_duration_minutes}
                                onChange={(e) => setEditingTemplate({...editingTemplate, max_duration_minutes: e.target.value ? parseInt(e.target.value) : ''})}
                                placeholder="Optional"
                              />
                            </div>
                          </div>
                          <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>
                            Bei Min/Max-Dauer wird die Einsatzdauer optimal verteilt, sodass alle Einsätze im angegebenen Bereich liegen.
                          </p>
                        </>
                      )}

                      {editingTemplate.shift_type === 'per_game' && (
                        <>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div>
                              <label>Start (Offset zum Spielbeginn)</label>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <input
                                  type="number"
                                  value={editingTemplate.start_offset_minutes}
                                  onChange={(e) => setEditingTemplate({...editingTemplate, start_offset_minutes: parseInt(e.target.value)})}
                                  style={{ width: '80px' }}
                                  required
                                />
                                <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                              </div>
                            </div>
                            <div>
                              <label>Dauer (Minuten)</label>
                              <input
                                type="number"
                                min="15"
                                step="15"
                                value={editingTemplate.duration_minutes}
                                onChange={(e) => setEditingTemplate({...editingTemplate, duration_minutes: parseInt(e.target.value)})}
                                required
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: '1rem' }}>
                            <label>Benötigte Helfer</label>
                            <input
                              type="number"
                              min="1"
                              value={editingTemplate.helpers_needed}
                              onChange={(e) => setEditingTemplate({...editingTemplate, helpers_needed: parseInt(e.target.value)})}
                              style={{ width: '100px' }}
                              required
                            />
                          </div>
                        </>
                      )}

                      {editingTemplate.shift_type === 'aufbau' && (
                        <>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div>
                              <label>Start (Offset zum 1. Spiel)</label>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <input
                                  type="number"
                                  value={editingTemplate.start_offset_minutes}
                                  onChange={(e) => setEditingTemplate({...editingTemplate, start_offset_minutes: parseInt(e.target.value)})}
                                  style={{ width: '80px' }}
                                  required
                                />
                                <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                              </div>
                            </div>
                            <div>
                              <label>Dauer (Minuten)</label>
                              <input
                                type="number"
                                min="15"
                                step="15"
                                value={editingTemplate.duration_minutes}
                                onChange={(e) => setEditingTemplate({...editingTemplate, duration_minutes: parseInt(e.target.value)})}
                                required
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: '1rem' }}>
                            <label>Benötigte Helfer</label>
                            <input
                              type="number"
                              min="1"
                              value={editingTemplate.helpers_needed}
                              onChange={(e) => setEditingTemplate({...editingTemplate, helpers_needed: parseInt(e.target.value)})}
                              style={{ width: '100px' }}
                              required
                            />
                          </div>
                        </>
                      )}

                      {editingTemplate.shift_type === 'abbau' && (
                        <>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                            <div>
                              <label>Start (Offset zum letzten Spiel)</label>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <input
                                  type="number"
                                  value={editingTemplate.start_offset_minutes}
                                  onChange={(e) => setEditingTemplate({...editingTemplate, start_offset_minutes: parseInt(e.target.value)})}
                                  style={{ width: '80px' }}
                                  required
                                />
                                <span style={{ color: '#666', fontSize: '0.85rem' }}>Min.</span>
                              </div>
                            </div>
                            <div>
                              <label>Dauer (Minuten)</label>
                              <input
                                type="number"
                                min="15"
                                step="15"
                                value={editingTemplate.duration_minutes}
                                onChange={(e) => setEditingTemplate({...editingTemplate, duration_minutes: parseInt(e.target.value)})}
                                required
                              />
                            </div>
                          </div>
                          <div style={{ marginTop: '1rem' }}>
                            <label>Benötigte Helfer</label>
                            <input
                              type="number"
                              min="1"
                              value={editingTemplate.helpers_needed}
                              onChange={(e) => setEditingTemplate({...editingTemplate, helpers_needed: parseInt(e.target.value)})}
                              style={{ width: '100px' }}
                              required
                            />
                          </div>
                        </>
                      )}

                      <div style={{ marginTop: '1rem' }}>
                        <label>Tags (Semikolon-getrennt)</label>
                        <input
                          type="text"
                          value={editingTemplate.tags}
                          onChange={(e) => setEditingTemplate({...editingTemplate, tags: e.target.value})}
                          placeholder="z.B. Bar; Kiosk; Turnhalle"
                          style={{ width: '100%' }}
                        />
                      </div>

                      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
                        <button type="submit" className="btn">
                          Speichern
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setEditingTemplate(null)}
                        >
                          Abbrechen
                        </button>
                      </div>
                    </form>
                  ) : (
                    /* Display Mode */
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <strong>{template.name}</strong>
                        <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                          {template.shift_type === 'per_event' && (
                            <>
                              Pro Event •
                              Start: {template.start_offset_minutes < 0
                                ? `${Math.abs(template.start_offset_minutes)} Min. vor 1. Spiel`
                                : template.start_offset_minutes > 0
                                  ? `${template.start_offset_minutes} Min. nach 1. Spiel`
                                  : 'Bei 1. Spiel'} •
                              Ende: {template.end_offset_minutes > 0
                                ? `${template.end_offset_minutes} Min. nach letztem Spiel`
                                : template.end_offset_minutes < 0
                                  ? `${Math.abs(template.end_offset_minutes)} Min. vor letztem Spiel`
                                  : 'Bei letztem Spiel'} •
                              {template.min_duration_minutes && template.max_duration_minutes
                                ? `${template.min_duration_minutes}-${template.max_duration_minutes} Min./Einsatz`
                                : `${template.duration_minutes} Min./Einsatz`} •
                              {template.helpers_needed} Helfer
                            </>
                          )}
                          {template.shift_type === 'per_game' && (
                            <>
                              Pro Spiel •
                              {template.start_offset_minutes < 0
                                ? `${Math.abs(template.start_offset_minutes)} Min. vor Spielbeginn`
                                : template.start_offset_minutes > 0
                                  ? `${template.start_offset_minutes} Min. nach Spielbeginn`
                                  : 'Bei Spielbeginn'} •
                              {template.duration_minutes} Min. •
                              {template.helpers_needed} Helfer
                            </>
                          )}
                          {template.shift_type === 'aufbau' && (
                            <>
                              Aufbau •
                              {template.start_offset_minutes < 0
                                ? `${Math.abs(template.start_offset_minutes)} Min. vor 1. Spiel`
                                : template.start_offset_minutes > 0
                                  ? `${template.start_offset_minutes} Min. nach 1. Spiel`
                                  : 'Bei 1. Spiel'} •
                              {template.duration_minutes} Min. •
                              {template.helpers_needed} Helfer
                            </>
                          )}
                          {template.shift_type === 'abbau' && (
                            <>
                              Abbau •
                              {template.start_offset_minutes > 0
                                ? `${template.start_offset_minutes} Min. nach letztem Spiel`
                                : template.start_offset_minutes < 0
                                  ? `${Math.abs(template.start_offset_minutes)} Min. vor letztem Spiel`
                                  : 'Bei letztem Spiel'} •
                              {template.duration_minutes} Min. •
                              {template.helpers_needed} Helfer
                            </>
                          )}
                        </div>
                        {template.tags && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem', marginTop: '0.5rem' }}>
                            {template.tags.split(/;\s*/).map((tag, idx) => {
                              const trimmedTag = tag.trim();
                              if (!trimmedTag) return null;
                              const color = getTagColor(trimmedTag);
                              return (
                                <span key={idx} style={{
                                  display: 'inline-block',
                                  padding: '0.15rem 0.5rem',
                                  borderRadius: '12px',
                                  fontSize: '0.75rem',
                                  fontWeight: '500',
                                  backgroundColor: color.bg,
                                  color: color.text,
                                  whiteSpace: 'nowrap'
                                }}>
                                  {trimmedTag}
                                </span>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button
                          onClick={() => startEditTemplate(template)}
                          className="btn"
                          style={{ padding: '0.5rem 1rem' }}
                        >
                          Bearbeiten
                        </button>
                        <button
                          onClick={() => handleDuplicateTemplateShift(template.id)}
                          className="btn"
                          style={{ padding: '0.5rem 1rem', backgroundColor: '#666' }}
                        >
                          Duplizieren
                        </button>
                        <button
                          onClick={() => handleDeleteTemplateShift(template.id)}
                          className="btn btn-danger"
                          style={{ padding: '0.5rem 1rem' }}
                        >
                          Löschen
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        </>
        )}

        {templateSubTab === 'event' && (
        <>
        <div className="card" style={{ marginBottom: '2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h3 style={{ margin: 0 }}>Event-Vorlagen</h3>
              <p style={{ margin: '0.5rem 0 0 0', color: '#666', fontSize: '0.9rem' }}>
                Event-Vorlagen gruppieren mehrere Einsatz-Vorlagen für bestimmte Event-Typen.
              </p>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <button className="btn" onClick={handleExportEventTemplates}>
                YAML Export
              </button>
              <label className="btn" style={{ cursor: 'pointer', margin: 0 }}>
                YAML Import
                <input
                  type="file"
                  accept=".yaml,.yml"
                  onChange={handleImportEventTemplates}
                  style={{ display: 'none' }}
                />
              </label>
              <button className="btn" onClick={() => setShowEventTemplateForm(!showEventTemplateForm)}>
                {showEventTemplateForm ? 'Abbrechen' : '+ Event-Vorlage hinzufügen'}
              </button>
            </div>
          </div>

          {showEventTemplateForm && (
            <form onSubmit={handleCreateEventTemplate} style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <div style={{ marginBottom: '1rem' }}>
                <label>Name *</label>
                <input
                  type="text"
                  value={newEventTemplate.name}
                  onChange={(e) => setNewEventTemplate({...newEventTemplate, name: e.target.value})}
                  placeholder="z.B. Heimspiel Standard, Turnier, etc."
                  required
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <label>Beschreibung</label>
                <input
                  type="text"
                  value={newEventTemplate.description}
                  onChange={(e) => setNewEventTemplate({...newEventTemplate, description: e.target.value})}
                  placeholder="Optionale Beschreibung"
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <label>Einsatz-Vorlagen auswählen</label>
                {templateShifts.length === 0 ? (
                  <p style={{ color: '#888', fontSize: '0.9rem' }}>Keine Einsatz-Vorlagen vorhanden. Erstelle zuerst Einsatz-Vorlagen.</p>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
                    {templateShifts.map(shift => (
                      <label key={shift.id} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={newEventTemplate.template_shift_ids.includes(shift.id)}
                          onChange={() => toggleShiftInEventTemplate(shift.id)}
                        />
                        <span>{shift.name}</span>
                        <span style={{ color: '#888', fontSize: '0.85rem' }}>
                          ({shift.shift_type === 'per_event' ? 'Pro Event' :
                            shift.shift_type === 'per_game' ? 'Pro Spiel' :
                            shift.shift_type === 'aufbau' ? 'Aufbau' : 'Abbau'})
                        </span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
              <button type="submit" className="btn" disabled={!newEventTemplate.name}>
                Event-Vorlage erstellen
              </button>
            </form>
          )}
        </div>

        <div className="card">
          <h3 style={{ marginBottom: '1rem' }}>Alle Event-Vorlagen ({eventTemplates.length})</h3>
          {eventTemplates.length === 0 ? (
            <p style={{ color: '#666' }}>Noch keine Event-Vorlagen definiert.</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {eventTemplates.map(template => (
                <div key={template.id} style={{
                  padding: '1rem',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '8px',
                  borderLeft: '4px solid #C62828'
                }}>
                  {editingEventTemplate && editingEventTemplate.id === template.id ? (
                    <form onSubmit={handleUpdateEventTemplate}>
                      <div style={{ marginBottom: '1rem' }}>
                        <label>Name *</label>
                        <input
                          type="text"
                          value={editingEventTemplate.name}
                          onChange={(e) => setEditingEventTemplate({...editingEventTemplate, name: e.target.value})}
                          required
                        />
                      </div>
                      <div style={{ marginBottom: '1rem' }}>
                        <label>Beschreibung</label>
                        <input
                          type="text"
                          value={editingEventTemplate.description || ''}
                          onChange={(e) => setEditingEventTemplate({...editingEventTemplate, description: e.target.value})}
                        />
                      </div>
                      <div style={{ marginBottom: '1rem' }}>
                        <label>Einsatz-Vorlagen</label>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
                          {templateShifts.map(shift => (
                            <label key={shift.id} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                              <input
                                type="checkbox"
                                checked={(editingEventTemplate.template_shift_ids || []).includes(shift.id)}
                                onChange={() => toggleShiftInEventTemplate(shift.id, true)}
                              />
                              <span>{shift.name}</span>
                              <span style={{ color: '#888', fontSize: '0.85rem' }}>
                                ({shift.shift_type === 'per_event' ? 'Pro Event' :
                                  shift.shift_type === 'per_game' ? 'Pro Spiel' :
                                  shift.shift_type === 'aufbau' ? 'Aufbau' : 'Abbau'})
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button type="submit" className="btn">Speichern</button>
                        <button type="button" className="btn" style={{ backgroundColor: '#666' }} onClick={() => setEditingEventTemplate(null)}>
                          Abbrechen
                        </button>
                      </div>
                    </form>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
                      <div>
                        <strong style={{ fontSize: '1.1rem' }}>{template.name}</strong>
                        {template.description && (
                          <p style={{ color: '#666', margin: '0.25rem 0 0.5rem 0', fontSize: '0.9rem' }}>{template.description}</p>
                        )}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.5rem' }}>
                          {template.template_shifts && template.template_shifts.length > 0 ? (
                            template.template_shifts.map(shift => (
                              <span key={shift.id} style={{
                                padding: '0.25rem 0.75rem',
                                backgroundColor: '#e3f2fd',
                                color: '#1565c0',
                                borderRadius: '12px',
                                fontSize: '0.85rem'
                              }}>
                                {shift.name}
                              </span>
                            ))
                          ) : (
                            <span style={{ color: '#888', fontStyle: 'italic', fontSize: '0.9rem' }}>Keine Einsatz-Vorlagen zugewiesen</span>
                          )}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button
                          onClick={() => setEditingEventTemplate({
                            id: template.id,
                            name: template.name,
                            description: template.description || '',
                            template_shift_ids: template.template_shift_ids || []
                          })}
                          className="btn"
                          style={{ padding: '0.5rem 1rem' }}
                        >
                          Bearbeiten
                        </button>
                        <button
                          onClick={() => handleDuplicateEventTemplate(template.id)}
                          className="btn"
                          style={{ padding: '0.5rem 1rem', backgroundColor: '#666' }}
                        >
                          Duplizieren
                        </button>
                        <button
                          onClick={() => handleDeleteEventTemplate(template.id)}
                          className="btn btn-danger"
                          style={{ padding: '0.5rem 1rem' }}
                        >
                          Löschen
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        </>
        )}
      </>
    );
  };

  const toggleAdmin = async (userId, currentStatus) => {
    try {
      await api.post(`/users/${userId}/admin`, { is_admin: !currentStatus });
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Ändern des Admin-Status');
    }
  };

  const toggleTeamAdmin = async (userId, currentStatus) => {
    try {
      await api.post(`/users/${userId}/admin`, { is_team_admin: !currentStatus });
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Ändern des Team-Admin-Status');
    }
  };

  const toggleColumn = (columnKey) => {
    const newColumns = { ...visibleColumns, [columnKey]: !visibleColumns[columnKey] };
    setVisibleColumns(newColumns);
    localStorage.setItem('adminUserColumns', JSON.stringify(newColumns));
  };

  const columnLabels = {
    name: 'Name',
    email: 'E-Mail',
    mobile: 'Mobile',
    age: 'Alter',
    helferpool: 'Helferpool',
    team: 'Team',
    last_login: 'Letzter Login',
    events: 'Eins. (Saison)',
    admin: 'Admin',
    team_admin: 'Team Admin'
  };

  const handleDeleteUser = async (userId, userEmail) => {
    if (window.confirm(`Benutzer "${userEmail}" wirklich löschen?`)) {
      try {
        await api.delete(`/users/${userId}`);
        loadUsers();
      } catch (error) {
        alert(error.response?.data?.message || 'Fehler beim Löschen');
      }
    }
  };

  const startEditUser = (user) => {
    setEditingUser({
      id: user.id,
      email: user.email,
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      mobile: user.mobile || '',
      date_of_birth: user.date_of_birth || '',
      helferpool: user.helferpool || '',
      team: user.team || ''
    });
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/users/${editingUser.id}`, {
        first_name: editingUser.first_name,
        last_name: editingUser.last_name,
        mobile: editingUser.mobile,
        date_of_birth: editingUser.date_of_birth || null,
        helferpool: editingUser.helferpool,
        team: editingUser.team
      });
      setEditingUser(null);
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Aktualisieren');
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      await api.post('/users', newUser);
      setNewUser({
        email: '',
        first_name: '',
        last_name: '',
        mobile: '',
        date_of_birth: '',
        helferpool: '',
        team: '',
        is_admin: false
      });
      setShowNewUserForm(false);
      loadUsers();
      alert('Benutzer erfolgreich angelegt!');
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Anlegen des Benutzers');
    }
  };

  const handleImportTeamsXlsx = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);
      const res = await api.post('/users/import-teams', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      let message = res.data.message;
      if (res.data.not_found_ids && res.data.not_found_ids.length > 0) {
        message += '\n\nNicht gefundene IDs: ' + res.data.not_found_ids.join(', ');
        if (res.data.not_found_count > 20) {
          message += ` ... und ${res.data.not_found_count - 20} weitere`;
        }
      }

      alert(message);
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Import');
    } finally {
      setLoading(false);
      // Reset file input
      if (teamImportRef.current) {
        teamImportRef.current.value = '';
      }
    }
  };

  const handleDeleteFairgateUsers = async () => {
    const fairgateUsersCount = users.filter(u => u.contact_id).length;
    if (fairgateUsersCount === 0) {
      alert('Keine Fairgate-Benutzer vorhanden.');
      return;
    }
    if (window.confirm(`Wirklich alle ${fairgateUsersCount} Benutzer mit Fairgate Contact ID löschen?\n\nDiese Aktion kann nicht rückgängig gemacht werden.`)) {
      try {
        const res = await api.delete('/users/fairgate');
        alert(res.data.message);
        loadUsers();
      } catch (error) {
        alert(error.response?.data?.message || 'Fehler beim Löschen');
      }
    }
  };

  const handleArchiveSelectedUsers = async () => {
    if (selectedUsers.length === 0) {
      alert('Keine Benutzer ausgewählt');
      return;
    }
    if (!window.confirm(`${selectedUsers.length} Benutzer archivieren?\n\nArchivierte Benutzer können nicht für Einsätze eingetragen werden.`)) {
      return;
    }
    try {
      const res = await api.post('/users/archive', { user_ids: selectedUsers });
      alert(res.data.message);
      setSelectedUsers([]);
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Archivieren');
    }
  };

  const handleUnarchiveSelectedUsers = async () => {
    if (selectedUsers.length === 0) {
      alert('Keine Benutzer ausgewählt');
      return;
    }
    if (!window.confirm(`${selectedUsers.length} Benutzer wiederherstellen?`)) {
      return;
    }
    try {
      const res = await api.post('/users/unarchive', { user_ids: selectedUsers });
      alert(res.data.message);
      setSelectedUsers([]);
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Wiederherstellen');
    }
  };

  const handleDeleteSelectedUsers = async () => {
    if (selectedUsers.length === 0) {
      alert('Keine Benutzer ausgewählt');
      return;
    }
    if (!window.confirm(`${selectedUsers.length} Benutzer endgültig löschen?\n\nDiese Aktion kann nicht rückgängig gemacht werden!`)) {
      return;
    }
    try {
      const res = await api.post('/users/delete-multiple', { user_ids: selectedUsers });
      alert(res.data.message);
      setSelectedUsers([]);
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Löschen');
    }
  };

  const toggleUserSelection = (userId) => {
    setSelectedUsers(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const toggleAllUsersSelection = (usersList) => {
    const allSelected = usersList.every(u => selectedUsers.includes(u.id));
    if (allSelected) {
      setSelectedUsers(prev => prev.filter(id => !usersList.some(u => u.id === id)));
    } else {
      const newIds = usersList.map(u => u.id);
      setSelectedUsers(prev => [...new Set([...prev, ...newIds])]);
    }
  };

  const handleCreateConnection = async (e) => {
    e.preventDefault();
    try {
      await api.post('/connections', newConnection);
      setNewConnection({ name: 'Data-Service handball.ch', url: '', path: '/clubs/{clubId}/games', auth_key: '', oid: '', membership: '', verein_id: '', postal_codes: '', account_sid: '', from_number: '', sender_type: 'phone' });
      setShowConnectionForm(false);
      loadConnections();
      alert('Verbindung erfolgreich erstellt!');
    } catch (error) {
      alert('Fehler beim Erstellen der Verbindung');
    }
  };

  const handleDeleteConnection = async (id) => {
    if (window.confirm('Verbindung wirklich löschen?')) {
      try {
        await api.delete(`/connections/${id}`);
        loadConnections();
      } catch (error) {
        alert('Fehler beim Löschen');
      }
    }
  };

  const handleTestSms = async (connectionId) => {
    if (!window.confirm('Test-SMS an deine hinterlegte Telefonnummer senden?')) return;

    try {
      const response = await api.post(`/connections/${connectionId}/test-sms`);
      alert(response.data.message);
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Senden der Test-SMS');
    }
  };

  const startEditConnection = (conn) => {
    setEditingConnection({
      id: conn.id,
      name: conn.name,
      url: conn.url,
      path: conn.path || '/clubs/{clubId}/games',
      auth_key: '',   // Don't prefill auth_key for security
      oid: conn.oid || '',
      membership: conn.membership || '',
      verein_id: conn.verein_id || '',
      postal_codes: conn.postal_codes || '',
      account_sid: conn.account_sid || '',
      from_number: conn.from_number || '',
      sender_type: conn.sender_type || 'phone'
    });
  };

  const handleUpdateConnection = async (e) => {
    e.preventDefault();
    try {
      const updateData = {
        name: editingConnection.name,
        url: editingConnection.url,
        path: editingConnection.path
      };
      // Only send auth_key if it was changed
      if (editingConnection.auth_key) {
        updateData.auth_key = editingConnection.auth_key;
      }
      // Send verein_id and postal_codes for Data-Service connections
      if (editingConnection.name === 'Data-Service handball.ch') {
        updateData.verein_id = editingConnection.verein_id;
        updateData.postal_codes = editingConnection.postal_codes;
      }
      // Send oid for Fairgate connections
      if (editingConnection.name === 'Fairgate REST API') {
        updateData.oid = editingConnection.oid;
        updateData.membership = editingConnection.membership;
      }
      // Send account_sid, from_number and sender_type for Twilio connections
      if (editingConnection.name === 'Twilio SMS API') {
        updateData.account_sid = editingConnection.account_sid;
        updateData.from_number = editingConnection.from_number;
        updateData.sender_type = editingConnection.sender_type;
      }

      await api.put(`/connections/${editingConnection.id}`, updateData);
      setEditingConnection(null);
      loadConnections();
      alert('Verbindung erfolgreich aktualisiert!');
    } catch (error) {
      alert('Fehler beim Aktualisieren der Verbindung');
    }
  };

  const handlePreviewHandballCh = async () => {
    setLoading(true);
    try {
      const payload = {};
      if (handballImportTemplateId) {
        payload.event_template_id = parseInt(handballImportTemplateId);
      }
      const res = await api.post('/import/handball-ch/preview', payload);
      setHandballPreview(res.data);
      setShowHandballPreview(true);
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Laden der Vorschau');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmHandballImport = async () => {
    setLoading(true);
    try {
      const payload = {};
      if (handballImportTemplateId) {
        payload.event_template_id = parseInt(handballImportTemplateId);
      }
      const res = await api.post('/import/handball-ch', payload);
      setShowHandballPreview(false);
      setHandballPreview(null);
      alert(res.data.message);
      loadEvents();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Import');
    } finally {
      setLoading(false);
    }
  };

  const handlePreviewFairgateUsers = async () => {
    setLoading(true);
    try {
      const res = await api.get('/import/fairgate-users/preview');
      setFairgatePreview(res.data);
      setShowFairgatePreview(true);
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Laden der Vorschau');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmFairgateImport = async () => {
    setLoading(true);
    try {
      const res = await api.post('/import/fairgate-users');
      setShowFairgatePreview(false);
      setFairgatePreview(null);
      alert(res.data.message);
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.message || 'Fehler beim Import');
    } finally {
      setLoading(false);
    }
  };

  const handleUserSort = (field) => {
    setUserSort(prev => ({
      field,
      direction: prev.field === field && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const getFilteredAndSortedUsers = () => {
    let filtered = users;

    // Filter out archived users (they appear in Archiv tab)
    filtered = filtered.filter(u => !u.is_archived);

    // Filter by search (name and email)
    if (userSearch.trim()) {
      const search = userSearch.toLowerCase();
      filtered = filtered.filter(u =>
        u.email.toLowerCase().includes(search) ||
        (u.first_name && u.first_name.toLowerCase().includes(search)) ||
        (u.last_name && u.last_name.toLowerCase().includes(search))
      );
    }

    // Filter by helferpool tags (user can have multiple pools separated by "; ")
    if (userHelferpoolFilter.length > 0) {
      const hasNoneFilter = userHelferpoolFilter.includes('__none__');
      const tagFilters = userHelferpoolFilter.filter(f => f !== '__none__');

      filtered = filtered.filter(u => {
        const userPools = u.helferpool
          ? u.helferpool.split(/;\s*/).map(p => p.trim()).filter(p => p)
          : [];

        // If "__none__" is selected, include users without tags
        if (hasNoneFilter && userPools.length === 0) {
          return true;
        }

        // If tag filters are selected, check if user has any of them
        if (tagFilters.length > 0) {
          return tagFilters.some(tag => userPools.includes(tag));
        }

        // Only __none__ filter and user has tags
        return false;
      });
    }

    // Filter by team tags (user can have multiple teams separated by "," or ";")
    if (userTeamFilter.length > 0) {
      const hasNoneFilter = userTeamFilter.includes('__none__');
      const tagFilters = userTeamFilter.filter(f => f !== '__none__');

      filtered = filtered.filter(u => {
        const userTeams = u.team
          ? u.team.split(/[,;]\s*/).map(t => t.trim()).filter(t => t)
          : [];

        // If "__none__" is selected, include users without teams
        if (hasNoneFilter && userTeams.length === 0) {
          return true;
        }

        // If tag filters are selected, check if user has any of them
        if (tagFilters.length > 0) {
          return tagFilters.some(tag => userTeams.includes(tag));
        }

        // Only __none__ filter and user has teams
        return false;
      });
    }

    // Sort
    return [...filtered].sort((a, b) => {
      let aVal, bVal;
      if (userSort.field === 'name') {
        aVal = `${a.last_name || ''} ${a.first_name || ''}`.toLowerCase().trim();
        bVal = `${b.last_name || ''} ${b.first_name || ''}`.toLowerCase().trim();
      } else if (userSort.field === 'email') {
        aVal = a.email.toLowerCase();
        bVal = b.email.toLowerCase();
      } else if (userSort.field === 'events') {
        aVal = a.helping_events_count || 0;
        bVal = b.helping_events_count || 0;
      } else if (userSort.field === 'admin') {
        aVal = a.is_super_admin ? 2 : (a.is_admin ? 1 : 0);
        bVal = b.is_super_admin ? 2 : (b.is_admin ? 1 : 0);
      } else if (userSort.field === 'team_admin') {
        aVal = a.is_team_admin ? 1 : 0;
        bVal = b.is_team_admin ? 1 : 0;
      } else if (userSort.field === 'contact_id') {
        aVal = a.contact_id || '';
        bVal = b.contact_id || '';
      } else if (userSort.field === 'helferpool') {
        aVal = (a.helferpool || '').toLowerCase();
        bVal = (b.helferpool || '').toLowerCase();
      } else if (userSort.field === 'team') {
        aVal = (a.team || '').toLowerCase();
        bVal = (b.team || '').toLowerCase();
      } else if (userSort.field === 'last_login') {
        aVal = a.last_login || '';
        bVal = b.last_login || '';
      } else if (userSort.field === 'age') {
        // Sort by date_of_birth (older first = earlier date first when asc)
        aVal = a.date_of_birth || '9999-12-31';
        bVal = b.date_of_birth || '9999-12-31';
      }

      if (aVal < bVal) return userSort.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return userSort.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const renderSortIcon = (field) => {
    if (userSort.field !== field) return ' ↕';
    return userSort.direction === 'asc' ? ' ↑' : ' ↓';
  };

  const renderUsers = () => {
    if (loading) return <div>Lädt...</div>;

    const filteredUsers = getFilteredAndSortedUsers();

    const fairgateUsersCount = users.filter(u => u.contact_id).length;

    // Get unique helferpool values for filter (split by "; " since users can have multiple)
    const allPools = users.flatMap(u =>
      u.helferpool ? u.helferpool.split(/;\s*/).map(p => p.trim()).filter(p => p) : []
    );
    const helferpoolValues = [...new Set(allPools)].sort();

    // Get unique team values for filter (split by "," or ";" since users can have multiple)
    const allTeams = users.flatMap(u =>
      u.team ? u.team.split(/[,;]\s*/).map(t => t.trim()).filter(t => t) : []
    );
    const teamValues = [...new Set(allTeams)].sort();

    const activeUsersCount = users.filter(u => !u.is_archived).length;

    return (
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '1rem' }}>
          <h3 style={{ margin: 0 }}>Aktive Benutzer ({activeUsersCount})</h3>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {selectedUsers.length > 0 && (
              <>
                <button
                  onClick={handleArchiveSelectedUsers}
                  className="btn"
                  style={{ padding: '0.5rem 1rem', backgroundColor: '#ff9800' }}
                >
                  {selectedUsers.length} archivieren
                </button>
                <button
                  onClick={handleDeleteSelectedUsers}
                  className="btn btn-danger"
                  style={{ padding: '0.5rem 1rem' }}
                >
                  {selectedUsers.length} löschen
                </button>
              </>
            )}
            <input
              type="text"
              value={userSearch}
              onChange={(e) => setUserSearch(e.target.value)}
              placeholder="Benutzer suchen..."
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                border: '1px solid #ddd',
                width: '250px',
                marginBottom: 0
              }}
            />
            {helferpoolValues.length > 0 && (
              <div style={{ position: 'relative' }}>
                <button
                  onClick={() => setShowTagFilter(!showTagFilter)}
                  style={{
                    padding: '0.5rem 1rem',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    backgroundColor: userHelferpoolFilter.length > 0 ? '#e3f2fd' : 'white',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                >
                  Tags filtern
                  {userHelferpoolFilter.length > 0 && (
                    <span style={{
                      backgroundColor: '#1565c0',
                      color: 'white',
                      borderRadius: '10px',
                      padding: '0 0.5rem',
                      fontSize: '0.8rem'
                    }}>
                      {userHelferpoolFilter.length}
                    </span>
                  )}
                </button>
                {showTagFilter && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 100,
                    minWidth: '200px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    marginTop: '4px'
                  }}>
                    <div style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>
                      <button
                        onClick={() => setUserHelferpoolFilter([])}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#666',
                          cursor: 'pointer',
                          fontSize: '0.85rem',
                          padding: '0.25rem 0'
                        }}
                      >
                        Filter zurücksetzen
                      </button>
                    </div>
                    <label style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      padding: '0.5rem 0.75rem',
                      cursor: 'pointer',
                      backgroundColor: userHelferpoolFilter.includes('__none__') ? '#f5f5f5' : 'transparent'
                    }}>
                      <input
                        type="checkbox"
                        checked={userHelferpoolFilter.includes('__none__')}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setUserHelferpoolFilter([...userHelferpoolFilter, '__none__']);
                          } else {
                            setUserHelferpoolFilter(userHelferpoolFilter.filter(f => f !== '__none__'));
                          }
                        }}
                      />
                      <span style={{
                        padding: '0.15rem 0.5rem',
                        borderRadius: '12px',
                        fontSize: '0.85rem',
                        backgroundColor: '#f5f5f5',
                        color: '#666',
                        fontStyle: 'italic'
                      }}>Ohne Helferpool</span>
                    </label>
                    {helferpoolValues.map(tag => {
                      const color = getTagColor(tag);
                      return (
                        <label key={tag} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          padding: '0.5rem 0.75rem',
                          cursor: 'pointer',
                          backgroundColor: userHelferpoolFilter.includes(tag) ? '#f5f5f5' : 'transparent'
                        }}>
                          <input
                            type="checkbox"
                            checked={userHelferpoolFilter.includes(tag)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setUserHelferpoolFilter([...userHelferpoolFilter, tag]);
                              } else {
                                setUserHelferpoolFilter(userHelferpoolFilter.filter(f => f !== tag));
                              }
                            }}
                          />
                          <span style={{
                            padding: '0.15rem 0.5rem',
                            borderRadius: '12px',
                            fontSize: '0.85rem',
                            backgroundColor: color.bg,
                            color: color.text
                          }}>
                            {tag}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {teamValues.length > 0 && (
              <div style={{ position: 'relative' }}>
                <button
                  onClick={() => setShowTeamFilter(!showTeamFilter)}
                  style={{
                    padding: '0.5rem 1rem',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    backgroundColor: userTeamFilter.length > 0 ? '#e8f5e9' : 'white',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                >
                  Team filtern
                  {userTeamFilter.length > 0 && (
                    <span style={{
                      backgroundColor: '#2e7d32',
                      color: 'white',
                      borderRadius: '10px',
                      padding: '0 0.5rem',
                      fontSize: '0.8rem'
                    }}>
                      {userTeamFilter.length}
                    </span>
                  )}
                </button>
                {showTeamFilter && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    zIndex: 100,
                    minWidth: '200px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    marginTop: '4px'
                  }}>
                    <div style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>
                      <button
                        onClick={() => setUserTeamFilter([])}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#666',
                          cursor: 'pointer',
                          fontSize: '0.85rem',
                          padding: '0.25rem 0'
                        }}
                      >
                        Filter zurücksetzen
                      </button>
                    </div>
                    <label style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      padding: '0.5rem 0.75rem',
                      cursor: 'pointer',
                      backgroundColor: userTeamFilter.includes('__none__') ? '#f5f5f5' : 'transparent'
                    }}>
                      <input
                        type="checkbox"
                        checked={userTeamFilter.includes('__none__')}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setUserTeamFilter([...userTeamFilter, '__none__']);
                          } else {
                            setUserTeamFilter(userTeamFilter.filter(f => f !== '__none__'));
                          }
                        }}
                      />
                      <span style={{
                        padding: '0.15rem 0.5rem',
                        borderRadius: '12px',
                        fontSize: '0.85rem',
                        backgroundColor: '#f5f5f5',
                        color: '#666',
                        fontStyle: 'italic'
                      }}>Ohne Team</span>
                    </label>
                    {teamValues.map(tag => {
                      const color = getTagColor(tag);
                      return (
                        <label key={tag} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          padding: '0.5rem 0.75rem',
                          cursor: 'pointer',
                          backgroundColor: userTeamFilter.includes(tag) ? '#f5f5f5' : 'transparent'
                        }}>
                          <input
                            type="checkbox"
                            checked={userTeamFilter.includes(tag)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setUserTeamFilter([...userTeamFilter, tag]);
                              } else {
                                setUserTeamFilter(userTeamFilter.filter(f => f !== tag));
                              }
                            }}
                          />
                          <span style={{
                            padding: '0.15rem 0.5rem',
                            borderRadius: '12px',
                            fontSize: '0.85rem',
                            backgroundColor: color.bg,
                            color: color.text
                          }}>
                            {tag}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {/* Column Configuration */}
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setShowColumnConfig(!showColumnConfig)}
                style={{
                  padding: '0.5rem 1rem',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  backgroundColor: showColumnConfig ? '#f5f5f5' : 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                Spalten
              </button>
              {showColumnConfig && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  right: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  zIndex: 100,
                  minWidth: '180px',
                  marginTop: '4px'
                }}>
                  {Object.entries(columnLabels).map(([key, label]) => (
                    <label key={key} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      padding: '0.5rem 0.75rem',
                      cursor: 'pointer',
                      backgroundColor: visibleColumns[key] ? '#f5f5f5' : 'transparent'
                    }}>
                      <input
                        type="checkbox"
                        checked={visibleColumns[key]}
                        onChange={() => toggleColumn(key)}
                      />
                      <span style={{ fontSize: '0.9rem' }}>{label}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>
            {user?.is_super_admin && (
              <button
                onClick={() => setShowNewUserForm(!showNewUserForm)}
                className="btn"
                style={{ padding: '0.5rem 1rem' }}
              >
                {showNewUserForm ? 'Abbrechen' : 'Benutzer hinzufügen'}
              </button>
            )}
            <input
              type="file"
              ref={teamImportRef}
              accept=".xlsx"
              style={{ display: 'none' }}
              onChange={handleImportTeamsXlsx}
            />
            <button
              onClick={() => teamImportRef.current?.click()}
              className="btn"
              style={{ padding: '0.5rem 1rem', backgroundColor: '#2e7d32' }}
              disabled={loading}
            >
              {loading ? 'Importiere...' : 'Teams importieren (XLSX)'}
            </button>
          </div>
        </div>

        {/* New User Form - only for super admin */}
        {user?.is_super_admin && showNewUserForm && (
          <form onSubmit={handleCreateUser} style={{ marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
            <h4 style={{ marginTop: 0, marginBottom: '1rem' }}>Neuen Benutzer anlegen</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              <div>
                <label>E-Mail *</label>
                <input
                  type="email"
                  value={newUser.email}
                  onChange={(e) => setNewUser({...newUser, email: e.target.value})}
                  required
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Vorname</label>
                <input
                  type="text"
                  value={newUser.first_name}
                  onChange={(e) => setNewUser({...newUser, first_name: e.target.value})}
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Nachname</label>
                <input
                  type="text"
                  value={newUser.last_name}
                  onChange={(e) => setNewUser({...newUser, last_name: e.target.value})}
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Mobile</label>
                <input
                  type="text"
                  value={newUser.mobile}
                  onChange={(e) => setNewUser({...newUser, mobile: e.target.value})}
                  placeholder="+41 79 123 45 67"
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Geburtsdatum</label>
                <input
                  type="date"
                  value={newUser.date_of_birth}
                  onChange={(e) => setNewUser({...newUser, date_of_birth: e.target.value})}
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Helferpool (Semikolon-getrennt)</label>
                <input
                  type="text"
                  value={newUser.helferpool}
                  onChange={(e) => setNewUser({...newUser, helferpool: e.target.value})}
                  placeholder="z.B. Bar; Kiosk"
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Team (Komma oder Semikolon-getrennt)</label>
                <input
                  type="text"
                  value={newUser.team}
                  onChange={(e) => setNewUser({...newUser, team: e.target.value})}
                  placeholder="z.B. U15, Damen 1"
                  style={{ width: '100%' }}
                />
              </div>
            </div>
            <div style={{ marginTop: '1rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={newUser.is_admin}
                  onChange={(e) => setNewUser({...newUser, is_admin: e.target.checked})}
                  style={{ width: 'auto', margin: 0 }}
                />
                Admin-Rechte
              </label>
            </div>
            <button type="submit" className="btn" style={{ marginTop: '1rem' }}>
              Benutzer anlegen
            </button>
          </form>
        )}

        {/* Edit User Form */}
        {editingUser && (
          <form onSubmit={handleUpdateUser} style={{ marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#e3f2fd', borderRadius: '4px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h4 style={{ margin: 0 }}>Benutzer bearbeiten: {editingUser.email}</h4>
              <button
                type="button"
                onClick={() => setEditingUser(null)}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666' }}
              >
                ×
              </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              <div>
                <label>Vorname</label>
                <input
                  type="text"
                  value={editingUser.first_name}
                  onChange={(e) => setEditingUser({...editingUser, first_name: e.target.value})}
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Nachname</label>
                <input
                  type="text"
                  value={editingUser.last_name}
                  onChange={(e) => setEditingUser({...editingUser, last_name: e.target.value})}
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Mobile</label>
                <input
                  type="text"
                  value={editingUser.mobile}
                  onChange={(e) => setEditingUser({...editingUser, mobile: e.target.value})}
                  placeholder="+41 79 123 45 67"
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Geburtsdatum</label>
                <input
                  type="date"
                  value={editingUser.date_of_birth}
                  onChange={(e) => setEditingUser({...editingUser, date_of_birth: e.target.value})}
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Helferpool (Semikolon-getrennt)</label>
                <input
                  type="text"
                  value={editingUser.helferpool}
                  onChange={(e) => setEditingUser({...editingUser, helferpool: e.target.value})}
                  placeholder="z.B. Bar; Kiosk"
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <label>Team (Komma oder Semikolon-getrennt)</label>
                <input
                  type="text"
                  value={editingUser.team}
                  onChange={(e) => setEditingUser({...editingUser, team: e.target.value})}
                  placeholder="z.B. U15, Damen 1"
                  style={{ width: '100%' }}
                />
              </div>
            </div>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <button type="submit" className="btn">
                Speichern
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => setEditingUser(null)}>
                Abbrechen
              </button>
            </div>
          </form>
        )}

        {filteredUsers.length === 0 ? (
          <p style={{ color: '#666' }}>
            {userSearch ? 'Keine Benutzer gefunden.' : 'Noch keine Benutzer registriert.'}
          </p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
                  <th style={{ padding: '0.4rem 0.5rem', textAlign: 'center', width: '40px' }}>
                    <input
                      type="checkbox"
                      checked={filteredUsers.length > 0 && filteredUsers.every(u => selectedUsers.includes(u.id))}
                      onChange={() => toggleAllUsersSelection(filteredUsers)}
                      title="Alle auswählen"
                    />
                  </th>
                  {visibleColumns.name && (
                    <th
                      onClick={() => handleUserSort('name')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'left', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Name{renderSortIcon('name')}
                    </th>
                  )}
                  {visibleColumns.email && (
                    <th
                      onClick={() => handleUserSort('email')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'left', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      E-Mail{renderSortIcon('email')}
                    </th>
                  )}
                  {visibleColumns.mobile && (
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', whiteSpace: 'nowrap' }}>
                      Mobile
                    </th>
                  )}
                  {visibleColumns.age && (
                    <th
                      onClick={() => handleUserSort('age')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'center', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Alter{renderSortIcon('age')}
                    </th>
                  )}
                  {visibleColumns.helferpool && (
                    <th
                      onClick={() => handleUserSort('helferpool')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'left', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Helferpool{renderSortIcon('helferpool')}
                    </th>
                  )}
                  {visibleColumns.team && (
                    <th
                      onClick={() => handleUserSort('team')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'left', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Team{renderSortIcon('team')}
                    </th>
                  )}
                  {visibleColumns.last_login && (
                    <th
                      onClick={() => handleUserSort('last_login')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'left', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Letzter Login{renderSortIcon('last_login')}
                    </th>
                  )}
                  {visibleColumns.events && (
                    <th
                      onClick={() => handleUserSort('events')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'center', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Eins.{renderSortIcon('events')}
                    </th>
                  )}
                  {visibleColumns.admin && (
                    <th
                      onClick={() => handleUserSort('admin')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'center', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Admin{renderSortIcon('admin')}
                    </th>
                  )}
                  {visibleColumns.team_admin && (
                    <th
                      onClick={() => handleUserSort('team_admin')}
                      style={{ padding: '0.4rem 0.5rem', textAlign: 'center', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
                    >
                      Team{renderSortIcon('team_admin')}
                    </th>
                  )}
                  <th style={{ padding: '0.4rem 0.5rem', textAlign: 'center', whiteSpace: 'nowrap' }}>Akt.</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((u) => (
                  <tr
                    key={u.id}
                    onClick={(e) => {
                      // Don't start editing if clicking checkbox or button
                      // Only local users can be edited (not Fairgate-imported users)
                      if (e.target.type !== 'checkbox' && e.target.tagName !== 'BUTTON' && !u.contact_id) {
                        startEditUser(u);
                      }
                    }}
                    style={{
                      borderBottom: '1px solid #e0e0e0',
                      cursor: u.contact_id ? 'default' : 'pointer',
                      transition: 'background-color 0.15s',
                      backgroundColor: selectedUsers.includes(u.id) ? '#fff3e0' : 'transparent'
                    }}
                    onMouseOver={(e) => {
                      if (!selectedUsers.includes(u.id)) {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (!selectedUsers.includes(u.id)) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }
                    }}
                  >
                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(u.id)}
                        onChange={() => toggleUserSelection(u.id)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </td>
                    {visibleColumns.name && (
                      <td style={{ padding: '0.4rem 0.5rem', whiteSpace: 'nowrap' }}>
                        {u.first_name || u.last_name ? (
                          <span>{u.first_name} {u.last_name}</span>
                        ) : (
                          <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>
                        )}
                      </td>
                    )}
                    {visibleColumns.email && (
                      <td style={{ padding: '0.4rem 0.5rem' }}>
                        {u.email}
                        {u.is_super_admin && (
                          <span style={{
                            marginLeft: '0.3rem',
                            padding: '0.1rem 0.3rem',
                            backgroundColor: '#ff9800',
                            color: 'white',
                            borderRadius: '3px',
                            fontSize: '0.65rem',
                            fontWeight: 'bold'
                          }}>
                            SUPER
                          </span>
                        )}
                      </td>
                    )}
                    {visibleColumns.mobile && (
                      <td style={{ padding: '0.4rem 0.5rem', whiteSpace: 'nowrap' }}>
                        {u.mobile || <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>}
                      </td>
                    )}
                    {visibleColumns.age && (
                      <td style={{ padding: '0.4rem 0.5rem', textAlign: 'center' }}>
                        {u.date_of_birth ? (
                          Math.floor((new Date() - new Date(u.date_of_birth)) / (365.25 * 24 * 60 * 60 * 1000))
                        ) : (
                          <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>
                        )}
                      </td>
                    )}
                    {visibleColumns.helferpool && (
                      <td style={{ padding: '0.4rem 0.5rem' }}>
                        {u.helferpool ? (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
                            {u.helferpool.split(/;\s*/).map((pool, idx) => {
                              const trimmedPool = pool.trim();
                              if (!trimmedPool) return null;
                              const color = getTagColor(trimmedPool);
                              return (
                                <span
                                  key={idx}
                                  style={{
                                    display: 'inline-block',
                                    padding: '0.15rem 0.5rem',
                                    borderRadius: '12px',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    backgroundColor: color.bg,
                                    color: color.text,
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  {trimmedPool}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>
                        )}
                      </td>
                    )}
                    {visibleColumns.team && (
                      <td style={{ padding: '0.4rem 0.5rem' }}>
                        {u.team ? (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
                            {u.team.split(/[,;]\s*/).map((team, idx) => {
                              const trimmedTeam = team.trim();
                              if (!trimmedTeam) return null;
                              const color = getTagColor(trimmedTeam);
                              return (
                                <span
                                  key={idx}
                                  style={{
                                    display: 'inline-block',
                                    padding: '0.15rem 0.5rem',
                                    borderRadius: '12px',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    backgroundColor: color.bg,
                                    color: color.text,
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  {trimmedTeam}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>
                        )}
                      </td>
                    )}
                    {visibleColumns.last_login && (
                      <td style={{ padding: '0.4rem 0.5rem', whiteSpace: 'nowrap', fontSize: '0.85rem' }}>
                        {u.last_login ? (
                          new Date(u.last_login).toLocaleDateString('de-CH', {
                            day: '2-digit',
                            month: '2-digit',
                            year: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                          })
                        ) : (
                          <span style={{ color: '#999', fontStyle: 'italic' }}>nie</span>
                        )}
                      </td>
                    )}
                    {visibleColumns.events && (
                      <td style={{ padding: '0.4rem 0.5rem', textAlign: 'center' }}>
                        {u.helping_events_count || 0}
                      </td>
                    )}
                    {visibleColumns.admin && (
                      <td style={{ padding: '0.4rem 0.5rem', textAlign: 'center' }}>
                        {u.is_super_admin ? (
                          <span style={{ color: '#ff9800', fontWeight: 'bold' }}>✓</span>
                        ) : (
                          <button
                            onClick={(e) => { e.stopPropagation(); toggleAdmin(u.id, u.is_admin); }}
                            style={{
                              padding: '0.15rem 0.4rem',
                              border: '1px solid',
                              borderColor: u.is_admin ? '#388e3c' : '#ddd',
                              backgroundColor: u.is_admin ? '#e8f5e9' : 'white',
                              color: u.is_admin ? '#388e3c' : '#666',
                              borderRadius: '3px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: u.is_admin ? 'bold' : 'normal'
                            }}
                          >
                            {u.is_admin ? '✓' : 'Admin'}
                          </button>
                        )}
                      </td>
                    )}
                    {visibleColumns.team_admin && (
                      <td style={{ padding: '0.4rem 0.5rem', textAlign: 'center' }}>
                        {!u.is_super_admin && (
                          <button
                            onClick={(e) => { e.stopPropagation(); toggleTeamAdmin(u.id, u.is_team_admin); }}
                            style={{
                              padding: '0.15rem 0.4rem',
                              border: '1px solid',
                              borderColor: u.is_team_admin ? '#1565c0' : '#ddd',
                              backgroundColor: u.is_team_admin ? '#e3f2fd' : 'white',
                              color: u.is_team_admin ? '#1565c0' : '#666',
                              borderRadius: '3px',
                              cursor: 'pointer',
                              fontSize: '0.75rem',
                              fontWeight: u.is_team_admin ? 'bold' : 'normal'
                            }}
                          >
                            {u.is_team_admin ? '✓' : 'Team'}
                          </button>
                        )}
                      </td>
                    )}
                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'center' }}>
                      {!u.is_super_admin && (
                        <button
                          onClick={(e) => { e.stopPropagation(); handleDeleteUser(u.id, u.email); }}
                          className="btn btn-danger"
                          style={{ padding: '0.15rem 0.4rem', fontSize: '0.75rem' }}
                        >
                          X
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const renderConnections = () => {
    if (loading) return <div>Lädt...</div>;

    // Group connections by name
    const groupedConnections = connections.reduce((acc, conn) => {
      if (!acc[conn.name]) {
        acc[conn.name] = [];
      }
      acc[conn.name].push(conn);
      return acc;
    }, {});

    return (
      <>
        {/* Reminder Settings Section */}
        <div className="card" style={{ marginBottom: '2rem' }}>
          <h3 style={{ marginBottom: '1rem' }}>Erinnerungen</h3>
          <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem' }}>
            Helfer werden vor ihrem Einsatz per SMS erinnert. Voraussetzung: Twilio SMS API ist konfiguriert.
          </p>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', margin: 0 }}>
              <input
                type="checkbox"
                checked={reminderSettings.enabled}
                onChange={(e) => setReminderSettings({ ...reminderSettings, enabled: e.target.checked })}
                style={{ width: '18px', height: '18px' }}
              />
              <span style={{ fontWeight: 'normal' }}>Erinnerungen aktiviert</span>
            </label>
          </div>

          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.9rem' }}>Tage vor dem Einsatz</label>
              <select
                value={reminderSettings.days_before}
                onChange={(e) => setReminderSettings({ ...reminderSettings, days_before: parseInt(e.target.value) })}
                style={{ padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd', minWidth: '120px' }}
                disabled={!reminderSettings.enabled}
              >
                <option value="1">1 Tag</option>
                <option value="2">2 Tage</option>
                <option value="3">3 Tage</option>
                <option value="7">7 Tage</option>
              </select>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.9rem' }}>Uhrzeit</label>
              <input
                type="time"
                value={reminderSettings.time}
                onChange={(e) => setReminderSettings({ ...reminderSettings, time: e.target.value })}
                style={{ padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd' }}
                disabled={!reminderSettings.enabled}
              />
            </div>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', margin: 0 }}>
              <input
                type="checkbox"
                checked={reminderSettings.email_fallback}
                onChange={(e) => setReminderSettings({ ...reminderSettings, email_fallback: e.target.checked })}
                disabled={!reminderSettings.enabled}
              />
              <span style={{ fontWeight: 'normal', color: reminderSettings.enabled ? 'inherit' : '#999' }}>
                E-Mail senden wenn keine Telefonnummer vorhanden
              </span>
            </label>
            <p style={{ color: '#888', fontSize: '0.8rem', marginTop: '0.25rem', marginLeft: '1.5rem' }}>
              Helfer ohne Telefonnummer erhalten die Erinnerung per E-Mail
            </p>
          </div>

          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
            <button className="btn" onClick={saveReminderSettings}>
              Einstellungen speichern
            </button>
            {reminderSettings.enabled && (
              <button
                className="btn"
                onClick={handleSendReminders}
                style={{ backgroundColor: '#2196f3' }}
              >
                Erinnerungen jetzt senden
              </button>
            )}
          </div>

          {/* Scheduler Status */}
          {reminderStatus && (
            <div style={{
              padding: '0.75rem 1rem',
              backgroundColor: reminderStatus.job_scheduled ? '#e8f5e9' : '#fff3e0',
              borderRadius: '4px',
              fontSize: '0.9rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <span style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: reminderStatus.job_scheduled ? '#4caf50' : '#ff9800',
                display: 'inline-block'
              }} />
              {reminderStatus.job_scheduled ? (
                <span>
                  Nächste Erinnerung:{' '}
                  <strong>
                    {new Date(reminderStatus.next_run).toLocaleDateString('de-CH', {
                      weekday: 'short',
                      day: 'numeric',
                      month: 'short',
                      hour: '2-digit',
                      minute: '2-digit'
                    })} Uhr
                  </strong>
                </span>
              ) : (
                <span style={{ color: '#e65100' }}>Kein Job geplant (Erinnerungen deaktiviert)</span>
              )}
            </div>
          )}
        </div>

        {/* Timezone Settings Section */}
        <div className="card" style={{ marginBottom: '2rem' }}>
          <h3 style={{ marginBottom: '1rem' }}>Zeitzone</h3>
          <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem' }}>
            Die Zeitzone wird für die Anzeige und Speicherung von Einsatzzeiten verwendet.
          </p>

          <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.25rem', fontSize: '0.9rem' }}>Zeitzone</label>
              <select
                value={timezoneSettings.timezone}
                onChange={(e) => setTimezoneSettings({ ...timezoneSettings, timezone: e.target.value })}
                style={{ padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd', minWidth: '200px' }}
              >
                {timezoneSettings.available_timezones.map(tz => (
                  <option key={tz} value={tz}>{tz}</option>
                ))}
              </select>
            </div>

            <button className="btn" onClick={saveTimezoneSettings}>
              Speichern
            </button>
          </div>
        </div>

        {/* Connections Section */}
        <h3 style={{ marginBottom: '1rem' }}>Verbindungen</h3>

        <div className="card" style={{ marginBottom: '2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h4 style={{ margin: 0 }}>Neue Verbindung hinzufügen</h4>
            <button className="btn" onClick={() => setShowConnectionForm(!showConnectionForm)}>
              {showConnectionForm ? 'Abbrechen' : '+ Verbindung hinzufügen'}
            </button>
          </div>

          {showConnectionForm && (
            <form onSubmit={handleCreateConnection} style={{ marginTop: '1.5rem' }}>
              <label>Schnittstellentyp</label>
              <select
                value={newConnection.name}
                onChange={(e) => setNewConnection({
                  ...newConnection,
                  name: e.target.value,
                  auth_key: '',
                  username: '',
                  password: '',
                  url: e.target.value === 'Twilio SMS API' ? 'https://api.twilio.com' : '',
                  path: e.target.value === 'Data-Service handball.ch' ? '/clubs/{clubId}/games' : ''
                })}
                style={{ padding: '0.75rem', width: '100%', marginBottom: '1rem', borderRadius: '4px', border: '1px solid #ddd' }}
                required
              >
                <option value="Data-Service handball.ch">Data-Service handball.ch</option>
                <option value="Fairgate REST API">Fairgate REST API</option>
                <option value="Twilio SMS API">Twilio SMS API</option>
              </select>

              <label>URL</label>
              <input
                type="url"
                value={newConnection.url}
                onChange={(e) => setNewConnection({...newConnection, url: e.target.value})}
                placeholder="https://..."
                required
              />

              {newConnection.name === 'Data-Service handball.ch' && (
                <>
                  <label>Verein ID</label>
                  <input
                    type="text"
                    value={newConnection.verein_id}
                    onChange={(e) => setNewConnection({...newConnection, verein_id: e.target.value})}
                    placeholder="z.B. 12345"
                    required
                  />

                  <label>Postleitzahlen (Heimspiele)</label>
                  <input
                    type="text"
                    value={newConnection.postal_codes}
                    onChange={(e) => setNewConnection({...newConnection, postal_codes: e.target.value})}
                    placeholder="z.B. 8610, 8600"
                    required
                  />
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                    Kommagetrennte PLZ - nur Spiele an diesen Orten werden importiert
                  </p>

                  <label>Pfad zum Spielplan</label>
                  <input
                    type="text"
                    value={newConnection.path}
                    onChange={(e) => setNewConnection({...newConnection, path: e.target.value})}
                    placeholder="/clubs/{clubId}/games"
                  />
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                    Platzhalter: {'{clubId}'} wird durch die Verein ID ersetzt
                  </p>

                  <label>Base64 Auth-Key</label>
                  <input
                    type="text"
                    value={newConnection.auth_key}
                    onChange={(e) => setNewConnection({...newConnection, auth_key: e.target.value})}
                    placeholder="Base64 encodierter Auth-Key"
                  />
                </>
              )}

              {newConnection.name === 'Fairgate REST API' && (
                <>
                  <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '1rem', backgroundColor: '#f5f5f5', padding: '0.75rem', borderRadius: '4px' }}>
                    Die Zugangsdaten erhalten Sie in Ihrem Fairgate-System unter Einstellungen → API-Zugang.
                  </p>

                  <label>Organisation ID (oid)</label>
                  <input
                    type="text"
                    value={newConnection.oid || ''}
                    onChange={(e) => setNewConnection({...newConnection, oid: e.target.value})}
                    placeholder="z.B. abc123..."
                    maxLength="25"
                    required
                  />
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                    Max. 25 Zeichen, Base64-kodiert
                  </p>

                  <label>Access Key</label>
                  <input
                    type="text"
                    value={newConnection.auth_key || ''}
                    onChange={(e) => setNewConnection({...newConnection, auth_key: e.target.value})}
                    placeholder="66-stelliger Access Key"
                    maxLength="66"
                    required
                  />
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                    66 Zeichen aus dem Fairgate-System
                  </p>

                  <label>Membership Filter (optional)</label>
                  <input
                    type="text"
                    value={newConnection.membership || ''}
                    onChange={(e) => setNewConnection({...newConnection, membership: e.target.value})}
                    placeholder="z.B. Mitglied"
                  />
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                    Filtert Kontakte nach Mitgliedschaftstyp. Leer lassen für alle Kontakte.
                  </p>
                </>
              )}

              {newConnection.name === 'Twilio SMS API' && (
                <>
                  <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '1rem', backgroundColor: '#f5f5f5', padding: '0.75rem', borderRadius: '4px' }}>
                    Die Zugangsdaten finden Sie in Ihrer Twilio Console unter Account → API keys & tokens.
                  </p>

                  <label>Account SID</label>
                  <input
                    type="text"
                    value={newConnection.account_sid || ''}
                    onChange={(e) => setNewConnection({...newConnection, account_sid: e.target.value})}
                    placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                    required
                  />
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                    34 Zeichen, beginnt mit "AC"
                  </p>

                  <label>Auth Token</label>
                  <input
                    type="password"
                    value={newConnection.auth_key || ''}
                    onChange={(e) => setNewConnection({...newConnection, auth_key: e.target.value})}
                    placeholder="Ihr Auth Token"
                    required
                  />
                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                    32-stelliger geheimer Schlüssel
                  </p>

                  <label>Absender-Typ</label>
                  <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '1rem' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontWeight: 'normal' }}>
                      <input
                        type="radio"
                        name="sender_type"
                        value="phone"
                        checked={newConnection.sender_type !== 'alphanumeric'}
                        onChange={() => setNewConnection({...newConnection, sender_type: 'phone', from_number: ''})}
                      />
                      Telefonnummer
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontWeight: 'normal' }}>
                      <input
                        type="radio"
                        name="sender_type"
                        value="alphanumeric"
                        checked={newConnection.sender_type === 'alphanumeric'}
                        onChange={() => setNewConnection({...newConnection, sender_type: 'alphanumeric', from_number: ''})}
                      />
                      Alphanumerische Sender ID
                    </label>
                  </div>

                  {newConnection.sender_type === 'alphanumeric' ? (
                    <>
                      <label>Sender ID</label>
                      <input
                        type="text"
                        value={newConnection.from_number || ''}
                        onChange={(e) => setNewConnection({...newConnection, from_number: e.target.value.slice(0, 11)})}
                        placeholder="z.B. TVUster"
                        maxLength="11"
                        required
                      />
                      <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                        Max. 11 Zeichen, nur Buchstaben und Zahlen, mind. 1 Buchstabe.
                        <br />
                        <span style={{ color: '#e65100' }}>Hinweis: Empfänger können nicht auf alphanumerische Sender IDs antworten.</span>
                      </p>
                    </>
                  ) : (
                    <>
                      <label>Absender-Telefonnummer</label>
                      <input
                        type="tel"
                        value={newConnection.from_number || ''}
                        onChange={(e) => setNewConnection({...newConnection, from_number: e.target.value})}
                        placeholder="+41791234567"
                        required
                      />
                      <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                        Ihre Twilio-Telefonnummer im internationalen Format (z.B. +41...)
                      </p>
                    </>
                  )}
                </>
              )}

              <button type="submit" className="btn" style={{ marginTop: '0.5rem' }}>
                Verbindung erstellen
              </button>
            </form>
          )}
        </div>

        {/* Import Section - handball.ch */}
        {groupedConnections['Data-Service handball.ch'] && groupedConnections['Data-Service handball.ch'].length > 0 && (
          <div className="card" style={{ marginBottom: '2rem', backgroundColor: '#e3f2fd' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
              <div>
                <h3 style={{ margin: 0, color: '#C62828' }}>handball.ch Import</h3>
                <p style={{ margin: '0.5rem 0 0 0', color: '#666', fontSize: '0.9rem' }}>
                  Importiere Spieldaten vom handball.ch Data-Service.
                </p>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                <select
                  value={handballImportTemplateId}
                  onChange={(e) => setHandballImportTemplateId(e.target.value)}
                  style={{
                    padding: '0.5rem',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontSize: '0.9rem'
                  }}
                >
                  <option value="">Alle Einsatz-Vorlagen</option>
                  {eventTemplates.map(template => (
                    <option key={template.id} value={template.id}>
                      {template.name}
                    </option>
                  ))}
                </select>
                <button
                  className="btn"
                  onClick={handlePreviewHandballCh}
                  disabled={loading}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {loading ? 'Lädt...' : 'Vorschau'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Import Section - Fairgate */}
        {groupedConnections['Fairgate REST API'] && groupedConnections['Fairgate REST API'].length > 0 && (
          <div className="card" style={{ marginBottom: '2rem', backgroundColor: '#e8f5e9' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h3 style={{ margin: 0, color: '#2e7d32' }}>Fairgate Import</h3>
                <p style={{ margin: '0.5rem 0 0 0', color: '#666', fontSize: '0.9rem' }}>
                  Importiere Benutzer von Fairgate (Contacts 2.0 API).
                </p>
              </div>
              <button
                className="btn"
                onClick={handlePreviewFairgateUsers}
                disabled={loading}
                style={{ whiteSpace: 'nowrap', backgroundColor: '#2e7d32' }}
              >
                {loading ? 'Lädt...' : 'Vorschau'}
              </button>
            </div>
          </div>
        )}

        <div className="card">
          <h3 style={{ marginBottom: '1rem' }}>Konfigurierte Verbindungen</h3>
          {Object.keys(groupedConnections).length === 0 ? (
            <p style={{ color: '#666' }}>Noch keine Verbindungen konfiguriert.</p>
          ) : (
            <div>
              {Object.entries(groupedConnections).map(([name, conns]) => (
                <div key={name} style={{ marginBottom: '2rem' }}>
                  <h4 style={{
                    color: '#C62828',
                    borderBottom: '2px solid #C62828',
                    paddingBottom: '0.5rem',
                    marginBottom: '1rem'
                  }}>
                    {name} ({conns.length})
                  </h4>
                  {conns.map((conn) => (
                    <div key={conn.id} style={{
                      padding: '1rem',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                      marginBottom: '0.5rem'
                    }}>
                      {editingConnection && editingConnection.id === conn.id ? (
                        /* Edit Form */
                        <form onSubmit={handleUpdateConnection}>
                          <label>URL</label>
                          <input
                            type="url"
                            value={editingConnection.url}
                            onChange={(e) => setEditingConnection({...editingConnection, url: e.target.value})}
                            placeholder="https://..."
                            required
                          />

                          {editingConnection.name === 'Data-Service handball.ch' && (
                            <>
                              <label>Verein ID</label>
                              <input
                                type="text"
                                value={editingConnection.verein_id}
                                onChange={(e) => setEditingConnection({...editingConnection, verein_id: e.target.value})}
                                placeholder="z.B. 12345"
                                required
                              />

                              <label>Postleitzahlen (Heimspiele)</label>
                              <input
                                type="text"
                                value={editingConnection.postal_codes}
                                onChange={(e) => setEditingConnection({...editingConnection, postal_codes: e.target.value})}
                                placeholder="z.B. 8610, 8600"
                                required
                              />
                              <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                                Kommagetrennte PLZ - nur Spiele an diesen Orten werden importiert
                              </p>

                              <label>Pfad zum Spielplan</label>
                              <input
                                type="text"
                                value={editingConnection.path}
                                onChange={(e) => setEditingConnection({...editingConnection, path: e.target.value})}
                                placeholder="/clubs/{clubId}/games"
                              />
                              <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                                Platzhalter: {'{clubId}'} wird durch die Verein ID ersetzt
                              </p>

                              <label>Base64 Auth-Key (leer lassen um nicht zu ändern)</label>
                              <input
                                type="text"
                                value={editingConnection.auth_key}
                                onChange={(e) => setEditingConnection({...editingConnection, auth_key: e.target.value})}
                                placeholder="Neuer Base64 Auth-Key"
                              />
                            </>
                          )}

                          {editingConnection.name === 'Fairgate REST API' && (
                            <>
                              <label>Organisation ID (oid)</label>
                              <input
                                type="text"
                                value={editingConnection.oid || ''}
                                onChange={(e) => setEditingConnection({...editingConnection, oid: e.target.value})}
                                placeholder="Organisation ID"
                                maxLength="25"
                                required
                              />

                              <label>Access Key (leer lassen um nicht zu ändern)</label>
                              <input
                                type="text"
                                value={editingConnection.auth_key || ''}
                                onChange={(e) => setEditingConnection({...editingConnection, auth_key: e.target.value})}
                                placeholder="Neuer 66-stelliger Access Key"
                                maxLength="66"
                              />

                              <label>Membership Filter (optional)</label>
                              <input
                                type="text"
                                value={editingConnection.membership || ''}
                                onChange={(e) => setEditingConnection({...editingConnection, membership: e.target.value})}
                                placeholder="z.B. Mitglied"
                              />
                              <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                                Filtert Kontakte nach Mitgliedschaftstyp. Leer lassen für alle Kontakte.
                              </p>
                            </>
                          )}

                          {editingConnection.name === 'Twilio SMS API' && (
                            <>
                              <label>Account SID</label>
                              <input
                                type="text"
                                value={editingConnection.account_sid || ''}
                                onChange={(e) => setEditingConnection({...editingConnection, account_sid: e.target.value})}
                                placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                                required
                              />

                              <label>Auth Token (leer lassen um nicht zu ändern)</label>
                              <input
                                type="password"
                                value={editingConnection.auth_key || ''}
                                onChange={(e) => setEditingConnection({...editingConnection, auth_key: e.target.value})}
                                placeholder="Neuer Auth Token"
                              />

                              <label>Absender-Typ</label>
                              <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '1rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="edit_sender_type"
                                    value="phone"
                                    checked={editingConnection.sender_type !== 'alphanumeric'}
                                    onChange={() => setEditingConnection({...editingConnection, sender_type: 'phone'})}
                                  />
                                  Telefonnummer
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="edit_sender_type"
                                    value="alphanumeric"
                                    checked={editingConnection.sender_type === 'alphanumeric'}
                                    onChange={() => setEditingConnection({...editingConnection, sender_type: 'alphanumeric'})}
                                  />
                                  Alphanumerische Sender ID
                                </label>
                              </div>

                              {editingConnection.sender_type === 'alphanumeric' ? (
                                <>
                                  <label>Sender ID</label>
                                  <input
                                    type="text"
                                    value={editingConnection.from_number || ''}
                                    onChange={(e) => setEditingConnection({...editingConnection, from_number: e.target.value.slice(0, 11)})}
                                    placeholder="z.B. TVUster"
                                    maxLength="11"
                                    required
                                  />
                                  <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '-0.5rem', marginBottom: '1rem' }}>
                                    Max. 11 Zeichen, nur Buchstaben und Zahlen
                                  </p>
                                </>
                              ) : (
                                <>
                                  <label>Absender-Telefonnummer</label>
                                  <input
                                    type="tel"
                                    value={editingConnection.from_number || ''}
                                    onChange={(e) => setEditingConnection({...editingConnection, from_number: e.target.value})}
                                    placeholder="+41791234567"
                                    required
                                  />
                                </>
                              )}
                            </>
                          )}

                          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
                            <button type="submit" className="btn">
                              Speichern
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => setEditingConnection(null)}
                            >
                              Abbrechen
                            </button>
                          </div>
                        </form>
                      ) : (
                        /* Display Mode */
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div style={{ flex: 1, wordBreak: 'break-all' }}>
                            <a
                              href={conn.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#C62828', textDecoration: 'none' }}
                            >
                              {conn.url}
                            </a>
                            {conn.name === 'Data-Service handball.ch' && (
                              <>
                                {conn.verein_id && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Verein ID: {conn.verein_id}
                                  </div>
                                )}
                                {conn.postal_codes && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    PLZ: {conn.postal_codes}
                                  </div>
                                )}
                                {conn.path && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Pfad: {conn.path}
                                  </div>
                                )}
                                {conn.has_auth_key && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Auth-Key gesetzt
                                  </div>
                                )}
                              </>
                            )}
                            {conn.name === 'Fairgate REST API' && (
                              <>
                                {conn.oid && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Organisation ID: {conn.oid}
                                  </div>
                                )}
                                {conn.membership && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Mitgliedschaft: {conn.membership}
                                  </div>
                                )}
                                {conn.has_auth_key && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Access Key gesetzt
                                  </div>
                                )}
                              </>
                            )}
                            {conn.name === 'Twilio SMS API' && (
                              <>
                                {conn.account_sid && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Account SID: {conn.account_sid}
                                  </div>
                                )}
                                {conn.from_number && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    {conn.sender_type === 'alphanumeric' ? 'Sender ID' : 'Absender'}: {conn.from_number}
                                    {conn.sender_type === 'alphanumeric' && (
                                      <span style={{ marginLeft: '0.5rem', padding: '0.1rem 0.4rem', backgroundColor: '#e3f2fd', borderRadius: '3px', fontSize: '0.75rem' }}>
                                        Alphanumerisch
                                      </span>
                                    )}
                                  </div>
                                )}
                                {conn.has_auth_key && (
                                  <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
                                    Auth Token gesetzt
                                  </div>
                                )}
                                {twilioBalances[conn.id] && !twilioBalances[conn.id].error && (
                                  <div style={{
                                    fontSize: '0.85rem',
                                    marginTop: '0.5rem',
                                    padding: '0.4rem 0.75rem',
                                    backgroundColor: parseFloat(twilioBalances[conn.id].balance) > 5 ? '#e8f5e9' : '#fff3e0',
                                    borderRadius: '4px',
                                    display: 'inline-block'
                                  }}>
                                    <strong>Guthaben:</strong> {parseFloat(twilioBalances[conn.id].balance).toFixed(2)} {twilioBalances[conn.id].currency}
                                  </div>
                                )}
                              </>
                            )}
                            <div style={{ fontSize: '0.85rem', color: '#888', marginTop: '0.25rem' }}>
                              Erstellt: {new Date(conn.created_at).toLocaleDateString('de-DE')}
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '0.5rem', marginLeft: '1rem', flexWrap: 'wrap' }}>
                            {conn.name === 'Twilio SMS API' && (
                              <button
                                onClick={() => handleTestSms(conn.id)}
                                className="btn"
                                style={{ padding: '0.5rem 1rem', backgroundColor: '#2196f3' }}
                              >
                                Test-SMS
                              </button>
                            )}
                            {conn.name === 'Fairgate REST API' && user?.is_super_admin && (
                              <button
                                onClick={handleDeleteFairgateUsers}
                                className="btn btn-danger"
                                style={{ padding: '0.5rem 1rem' }}
                              >
                                Benutzer löschen ({users.filter(u => u.contact_id).length})
                              </button>
                            )}
                            <button
                              onClick={() => startEditConnection(conn)}
                              className="btn"
                              style={{ padding: '0.5rem 1rem' }}
                            >
                              Bearbeiten
                            </button>
                            <button
                              onClick={() => handleDeleteConnection(conn.id)}
                              className="btn btn-danger"
                              style={{ padding: '0.5rem 1rem' }}
                            >
                              Löschen
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>

      {/* Reminder Preview Modal */}
      {showReminderPreview && reminderPreview && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="card" style={{
            maxWidth: '700px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            margin: '1rem'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ margin: 0 }}>Erinnerungen senden - Vorschau</h3>
              <button
                onClick={() => { setShowReminderPreview(false); setReminderPreview(null); }}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666' }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '1rem', padding: '0.75rem', backgroundColor: '#e3f2fd', borderRadius: '4px' }}>
              <strong>Zieldatum:</strong>{' '}
              {new Date(reminderPreview.target_date).toLocaleDateString('de-CH', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
              {' '}(in {reminderPreview.days_before} {reminderPreview.days_before === 1 ? 'Tag' : 'Tagen'})
            </div>

            <div style={{ marginBottom: '1rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#e8f5e9', borderRadius: '4px' }}>
                <strong style={{ color: '#2e7d32' }}>{reminderPreview.total_sms}</strong> SMS werden gesendet
              </div>
              {reminderPreview.total_skipped > 0 && (
                <div style={{ padding: '0.5rem 1rem', backgroundColor: '#fff3e0', borderRadius: '4px' }}>
                  <strong style={{ color: '#ef6c00' }}>{reminderPreview.total_skipped}</strong> ohne Telefonnummer
                </div>
              )}
            </div>

            {reminderPreview.recipients.length === 0 ? (
              <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
                Keine Empfänger für das Zieldatum gefunden.
              </div>
            ) : (
              <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '1rem' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead style={{ backgroundColor: '#f5f5f5', position: 'sticky', top: 0 }}>
                    <tr>
                      <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Name</th>
                      <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Telefon</th>
                      <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Einsatz</th>
                      <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Zeit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reminderPreview.recipients.map((r, idx) => (
                      <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                        <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{r.name}</td>
                        <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee', fontFamily: 'monospace' }}>{r.mobile}</td>
                        <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>
                          <div style={{ fontSize: '0.9rem' }}>{r.event_title}</div>
                          <div style={{ fontSize: '0.8rem', color: '#666' }}>{r.shift_name}</div>
                        </td>
                        <td style={{ padding: '0.5rem', borderBottom: '1px solid #eee' }}>{r.shift_time}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {reminderPreview.skipped.length > 0 && (
              <details style={{ marginBottom: '1rem' }}>
                <summary style={{ cursor: 'pointer', color: '#666', fontSize: '0.9rem' }}>
                  {reminderPreview.skipped.length} Helfer ohne Telefonnummer anzeigen
                </summary>
                <div style={{ marginTop: '0.5rem', padding: '0.5rem', backgroundColor: '#fff3e0', borderRadius: '4px', fontSize: '0.85rem' }}>
                  {reminderPreview.skipped.map((s, idx) => (
                    <div key={idx} style={{ padding: '0.25rem 0' }}>
                      {s.name} ({s.email}) - {s.shift_name}
                    </div>
                  ))}
                </div>
              </details>
            )}

            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
              <button
                className="btn btn-secondary"
                onClick={() => { setShowReminderPreview(false); setReminderPreview(null); }}
              >
                Abbrechen
              </button>
              <button
                className="btn"
                onClick={confirmSendReminders}
                disabled={reminderPreview.total_sms === 0}
                style={{ backgroundColor: reminderPreview.total_sms > 0 ? '#2196f3' : '#ccc' }}
              >
                {reminderPreview.total_sms} SMS jetzt senden
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Handball.ch Preview Modal */}
      {showHandballPreview && handballPreview && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="card" style={{
            maxWidth: '800px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            margin: '1rem'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ margin: 0 }}>Handball.ch Import - Vorschau</h3>
              <button
                onClick={() => { setShowHandballPreview(false); setHandballPreview(null); }}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666' }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '1rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#e8f5e9', borderRadius: '4px' }}>
                <strong style={{ color: '#2e7d32' }}>{handballPreview.items?.filter(i => i.import_status === 'import').length || 0}</strong> neue Events
              </div>
              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#fff3e0', borderRadius: '4px' }}>
                <strong style={{ color: '#ef6c00' }}>{handballPreview.items?.filter(i => i.import_status === 'exists').length || 0}</strong> bereits vorhanden
              </div>
              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ffebee', borderRadius: '4px' }}>
                <strong style={{ color: '#c62828' }}>{handballPreview.items?.filter(i => i.import_status === 'ignore').length || 0}</strong> ignoriert
              </div>
            </div>

            <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '1rem' }}>
              {handballPreview.items?.length === 0 ? (
                <p style={{ padding: '1rem', color: '#666', textAlign: 'center' }}>Keine Events gefunden</p>
              ) : (
                handballPreview.items?.map((item, idx) => (
                  <div key={idx} style={{
                    padding: '0.75rem',
                    borderBottom: '1px solid #eee',
                    backgroundColor: item.import_status === 'import' ? '#e8f5e9' :
                                    item.import_status === 'exists' ? '#fff3e0' : '#ffebee'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '0.5rem' }}>
                      <div>
                        <div style={{ fontWeight: 'bold' }}>{item.title}</div>
                        <div style={{ fontSize: '0.85rem', color: '#666' }}>
                          {new Date(item.date).toLocaleDateString('de-DE')} • {item.location}
                        </div>
                        {item.ignore_reason && (
                          <div style={{ fontSize: '0.8rem', color: '#c62828', marginTop: '0.25rem' }}>
                            {item.ignore_reason}
                          </div>
                        )}
                      </div>
                      <span style={{
                        padding: '0.25rem 0.5rem',
                        borderRadius: '4px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        backgroundColor: item.import_status === 'import' ? '#4caf50' :
                                        item.import_status === 'exists' ? '#ff9800' : '#f44336',
                        color: 'white'
                      }}>
                        {item.import_status === 'import' ? 'NEU' :
                         item.import_status === 'exists' ? 'VORHANDEN' : 'IGNORIERT'}
                      </span>
                    </div>
                  </div>
                ))
              )}
            </div>

            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <button
                className="btn"
                onClick={handleConfirmHandballImport}
                disabled={loading || !handballPreview.items?.some(i => i.import_status === 'import')}
                style={{ backgroundColor: '#4caf50' }}
              >
                {loading ? 'Importiere...' : `${handballPreview.items?.filter(i => i.import_status === 'import').length || 0} Events importieren`}
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => { setShowHandballPreview(false); setHandballPreview(null); }}
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Fairgate Users Preview Modal */}
      {showFairgatePreview && fairgatePreview && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="card" style={{
            maxWidth: '800px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            margin: '1rem'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ margin: 0 }}>Fairgate Import - Vorschau</h3>
              <button
                onClick={() => { setShowFairgatePreview(false); setFairgatePreview(null); }}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666' }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '1rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#e8f5e9', borderRadius: '4px' }}>
                <strong style={{ color: '#2e7d32' }}>{fairgatePreview.items?.filter(i => i.import_status === 'import').length || 0}</strong> neue Benutzer
              </div>
              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#e3f2fd', borderRadius: '4px' }}>
                <strong style={{ color: '#1565c0' }}>{fairgatePreview.items?.filter(i => i.import_status === 'update').length || 0}</strong> aktualisieren
              </div>
              <div style={{ padding: '0.5rem 1rem', backgroundColor: '#ffebee', borderRadius: '4px' }}>
                <strong style={{ color: '#c62828' }}>{fairgatePreview.items?.filter(i => i.import_status === 'ignore').length || 0}</strong> ignoriert
              </div>
            </div>

            <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '1rem' }}>
              {fairgatePreview.items?.length === 0 ? (
                <p style={{ padding: '1rem', color: '#666', textAlign: 'center' }}>Keine Benutzer gefunden</p>
              ) : (
                fairgatePreview.items?.map((item, idx) => (
                  <div key={idx} style={{
                    padding: '0.75rem',
                    borderBottom: '1px solid #eee',
                    backgroundColor: item.import_status === 'import' ? '#e8f5e9' :
                                    item.import_status === 'update' ? '#e3f2fd' : '#ffebee'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '0.5rem' }}>
                      <div>
                        <div style={{ fontWeight: 'bold' }}>
                          {item.first_name} {item.last_name}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: '#666' }}>
                          {item.email}
                          {item.helferpool && ` • ${item.helferpool}`}
                        </div>
                        {item.ignore_reason && (
                          <div style={{ fontSize: '0.8rem', color: '#c62828', marginTop: '0.25rem' }}>
                            {item.ignore_reason}
                          </div>
                        )}
                      </div>
                      <span style={{
                        padding: '0.25rem 0.5rem',
                        borderRadius: '4px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        backgroundColor: item.import_status === 'import' ? '#4caf50' :
                                        item.import_status === 'update' ? '#2196f3' : '#f44336',
                        color: 'white'
                      }}>
                        {item.import_status === 'import' ? 'NEU' :
                         item.import_status === 'update' ? 'UPDATE' : 'IGNORIERT'}
                      </span>
                    </div>
                  </div>
                ))
              )}
            </div>

            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <button
                className="btn"
                onClick={handleConfirmFairgateImport}
                disabled={loading || !fairgatePreview.items?.some(i => i.import_status === 'import' || i.import_status === 'update')}
                style={{ backgroundColor: '#2e7d32' }}
              >
                {loading ? 'Importiere...' : `${(fairgatePreview.items?.filter(i => i.import_status === 'import').length || 0) + (fairgatePreview.items?.filter(i => i.import_status === 'update').length || 0)} Benutzer importieren`}
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => { setShowFairgatePreview(false); setFairgatePreview(null); }}
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      )}
      </>
    );
  };

  const handleSeasonToggle = (season) => {
    const newSeasons = statisticsSeasons.includes(season)
      ? statisticsSeasons.filter(s => s !== season)
      : [...statisticsSeasons, season];
    setStatisticsSeasons(newSeasons);
    loadStatistics(newSeasons);
  };

  const handleSelectAllSeasons = () => {
    if (statistics?.available_seasons) {
      if (statisticsSeasons.length === statistics.available_seasons.length) {
        // All selected -> deselect all (show all data)
        setStatisticsSeasons([]);
        loadStatistics([]);
      } else {
        // Select all
        setStatisticsSeasons([...statistics.available_seasons]);
        loadStatistics([...statistics.available_seasons]);
      }
    }
  };

  const renderStatistik = () => {
    if (loading) return <div>Lädt...</div>;
    if (!statistics) return <div>Keine Statistiken verfügbar</div>;

    return (
      <>
        {/* Season Filter */}
        {statistics.available_seasons && statistics.available_seasons.length > 0 && (
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
              <h3 style={{ margin: 0 }}>Saison-Filter</h3>
              <button
                onClick={handleSelectAllSeasons}
                style={{
                  background: 'none',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '0.25rem 0.75rem',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  color: '#666'
                }}
              >
                {statisticsSeasons.length === statistics.available_seasons.length ? 'Alle abwählen' : 'Alle auswählen'}
              </button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
              {statistics.available_seasons.map(season => (
                <button
                  key={season}
                  onClick={() => handleSeasonToggle(season)}
                  style={{
                    padding: '0.5rem 1rem',
                    borderRadius: '20px',
                    border: statisticsSeasons.includes(season) ? '2px solid #C62828' : '2px solid #ddd',
                    backgroundColor: statisticsSeasons.includes(season) ? '#ffebee' : '#f5f5f5',
                    color: statisticsSeasons.includes(season) ? '#C62828' : '#666',
                    cursor: 'pointer',
                    fontWeight: statisticsSeasons.includes(season) ? 'bold' : 'normal',
                    fontSize: '0.9rem'
                  }}
                >
                  Saison {season}
                </button>
              ))}
            </div>
            {statisticsSeasons.length === 0 && (
              <p style={{ margin: '0.75rem 0 0 0', color: '#888', fontSize: '0.85rem' }}>
                Kein Filter aktiv - alle Saisons werden angezeigt
              </p>
            )}
          </div>
        )}

        {/* Overview Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          marginBottom: '2rem'
        }}>
          <div className="card" style={{ textAlign: 'center', backgroundColor: '#e3f2fd' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#1565c0' }}>
              {statistics.total_events}
            </div>
            <div style={{ color: '#666' }}>Total Events</div>
          </div>

          <div className="card" style={{ textAlign: 'center', backgroundColor: '#e8f5e9' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#2e7d32' }}>
              {statistics.total_shifts}
            </div>
            <div style={{ color: '#666' }}>Total Einsätze</div>
          </div>

          <div className="card" style={{ textAlign: 'center', backgroundColor: '#fff3e0' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#ef6c00' }}>
              {statistics.total_helper_assignments}
            </div>
            <div style={{ color: '#666' }}>Total Helfereinsätze</div>
          </div>

          <div className="card" style={{ textAlign: 'center', backgroundColor: '#fce4ec' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#c2185b' }}>
              {statistics.total_helper_hours}h
            </div>
            <div style={{ color: '#666' }}>Total Helferstunden</div>
          </div>

          <div className="card" style={{ textAlign: 'center', backgroundColor: '#f3e5f5' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#7b1fa2' }}>
              {statistics.total_users}
            </div>
            <div style={{ color: '#666' }}>Total Benutzer</div>
          </div>

          <div className="card" style={{ textAlign: 'center', backgroundColor: '#e0f2f1' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#00695c' }}>
              {statistics.active_helpers}
            </div>
            <div style={{ color: '#666' }}>Aktive Helfer</div>
          </div>
        </div>

        {/* Details Section */}
        <div className="card">
          <h3 style={{ marginBottom: '1rem' }}>Details</h3>

          {/* Helfer mit Einsätzen */}
          <div
            style={{
              padding: '1rem',
              backgroundColor: '#e8f5e9',
              borderRadius: '8px',
              cursor: 'pointer',
              marginBottom: '1rem'
            }}
            onClick={() => setShowActiveHelpers(!showActiveHelpers)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <strong>Helfer mit Einsätzen:</strong> {statistics.active_helpers}
              </span>
              <span style={{ color: '#666' }}>
                {showActiveHelpers ? '▲' : '▼'}
              </span>
            </div>
          </div>

          {showActiveHelpers && statistics.helpers_with_shifts && statistics.helpers_with_shifts.length > 0 && (
            <div style={{ marginBottom: '1rem' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
                    <th
                      style={{ padding: '0.5rem', textAlign: 'left', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => setActiveHelpersSort(prev => ({
                        field: 'name',
                        direction: prev.field === 'name' && prev.direction === 'asc' ? 'desc' : 'asc'
                      }))}
                    >
                      Name {activeHelpersSort.field === 'name' && (activeHelpersSort.direction === 'asc' ? '▲' : '▼')}
                    </th>
                    <th
                      style={{ padding: '0.5rem', textAlign: 'left', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => setActiveHelpersSort(prev => ({
                        field: 'email',
                        direction: prev.field === 'email' && prev.direction === 'asc' ? 'desc' : 'asc'
                      }))}
                    >
                      E-Mail {activeHelpersSort.field === 'email' && (activeHelpersSort.direction === 'asc' ? '▲' : '▼')}
                    </th>
                    <th
                      style={{ padding: '0.5rem', textAlign: 'right', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => setActiveHelpersSort(prev => ({
                        field: 'shift_count',
                        direction: prev.field === 'shift_count' && prev.direction === 'desc' ? 'asc' : 'desc'
                      }))}
                    >
                      Einsätze {activeHelpersSort.field === 'shift_count' && (activeHelpersSort.direction === 'asc' ? '▲' : '▼')}
                    </th>
                    <th
                      style={{ padding: '0.5rem', textAlign: 'right', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => setActiveHelpersSort(prev => ({
                        field: 'total_hours',
                        direction: prev.field === 'total_hours' && prev.direction === 'desc' ? 'asc' : 'desc'
                      }))}
                    >
                      Stunden {activeHelpersSort.field === 'total_hours' && (activeHelpersSort.direction === 'asc' ? '▲' : '▼')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...statistics.helpers_with_shifts].sort((a, b) => {
                    const dir = activeHelpersSort.direction === 'asc' ? 1 : -1;
                    if (activeHelpersSort.field === 'name') {
                      const nameA = `${a.first_name || ''} ${a.last_name || ''}`.trim().toLowerCase();
                      const nameB = `${b.first_name || ''} ${b.last_name || ''}`.trim().toLowerCase();
                      return nameA.localeCompare(nameB) * dir;
                    } else if (activeHelpersSort.field === 'email') {
                      return a.email.localeCompare(b.email) * dir;
                    } else if (activeHelpersSort.field === 'shift_count') {
                      return (a.shift_count - b.shift_count) * dir;
                    } else if (activeHelpersSort.field === 'total_hours') {
                      return (a.total_hours - b.total_hours) * dir;
                    }
                    return 0;
                  }).map((user) => (
                    <tr key={user.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                      <td style={{ padding: '0.5rem' }}>
                        {user.first_name || user.last_name
                          ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
                          : '-'}
                      </td>
                      <td style={{ padding: '0.5rem' }}>{user.email}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'right' }}>{user.shift_count}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'right' }}>{user.total_hours}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Helfer ohne Einsätze */}
          <div
            style={{
              padding: '1rem',
              backgroundColor: statistics.inactive_helpers_count > 0 ? '#fff3e0' : '#e8f5e9',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
            onClick={() => setShowInactiveHelpers(!showInactiveHelpers)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>
                <strong>Helfer ohne Einsätze:</strong> {statistics.inactive_helpers_count}
              </span>
              <span style={{ color: '#666' }}>
                {showInactiveHelpers ? '▲' : '▼'}
              </span>
            </div>
          </div>

          {showInactiveHelpers && statistics.helpers_without_shifts && statistics.helpers_without_shifts.length > 0 && (
            <div style={{ marginTop: '1rem' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
                    <th style={{ padding: '0.5rem', textAlign: 'left' }}>Name</th>
                    <th style={{ padding: '0.5rem', textAlign: 'left' }}>E-Mail</th>
                  </tr>
                </thead>
                <tbody>
                  {statistics.helpers_without_shifts.map((user) => (
                    <tr key={user.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                      <td style={{ padding: '0.5rem' }}>
                        {user.first_name || user.last_name
                          ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
                          : '-'}
                      </td>
                      <td style={{ padding: '0.5rem' }}>{user.email}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </>
    );
  };

  const renderArchiv = () => {
    if (loading) return <div>Lädt...</div>;

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString('de-DE', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    };

    // Get active and archived users
    const activeUsers = users.filter(u => !u.is_archived);
    const archivedUsers = users.filter(u => u.is_archived);

    // Get filtered users based on current subtab context
    const displayUsers = archivSubTab === 'users' ? archivedUsers : activeUsers;

    return (
      <>
        {/* Subtab Navigation */}
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', borderBottom: '1px solid #e0e0e0' }}>
          <button
            onClick={() => { setArchivSubTab('events'); setSelectedUsers([]); }}
            style={{
              padding: '0.75rem 1.5rem',
              border: 'none',
              background: archivSubTab === 'events' ? '#C62828' : 'transparent',
              color: archivSubTab === 'events' ? 'white' : '#666',
              cursor: 'pointer',
              borderRadius: '4px 4px 0 0',
              fontWeight: archivSubTab === 'events' ? 'bold' : 'normal'
            }}
          >
            Events ({archivedEvents.length})
          </button>
          <button
            onClick={() => { setArchivSubTab('users'); setSelectedUsers([]); }}
            style={{
              padding: '0.75rem 1.5rem',
              border: 'none',
              background: archivSubTab === 'users' ? '#C62828' : 'transparent',
              color: archivSubTab === 'users' ? 'white' : '#666',
              cursor: 'pointer',
              borderRadius: '4px 4px 0 0',
              fontWeight: archivSubTab === 'users' ? 'bold' : 'normal'
            }}
          >
            Benutzer ({archivedUsers.length})
          </button>
        </div>

        {/* Archived Users Subtab */}
        {archivSubTab === 'users' && (
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '1rem' }}>
              <h3 style={{ margin: 0 }}>Archivierte Benutzer ({archivedUsers.length})</h3>
              {selectedUsers.length > 0 && (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <button
                    onClick={handleUnarchiveSelectedUsers}
                    className="btn"
                    style={{ padding: '0.5rem 1rem', backgroundColor: '#2e7d32' }}
                  >
                    {selectedUsers.length} wiederherstellen
                  </button>
                  <button
                    onClick={handleDeleteSelectedUsers}
                    className="btn btn-danger"
                    style={{ padding: '0.5rem 1rem' }}
                  >
                    {selectedUsers.length} löschen
                  </button>
                </div>
              )}
            </div>

            {archivedUsers.length === 0 ? (
              <p style={{ color: '#666', textAlign: 'center' }}>Keine archivierten Benutzer vorhanden.</p>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                      <th style={{ padding: '0.5rem', textAlign: 'center', width: '40px' }}>
                        <input
                          type="checkbox"
                          checked={archivedUsers.length > 0 && archivedUsers.every(u => selectedUsers.includes(u.id))}
                          onChange={() => toggleAllUsersSelection(archivedUsers)}
                        />
                      </th>
                      <th style={{ padding: '0.5rem', textAlign: 'left' }}>Name</th>
                      <th style={{ padding: '0.5rem', textAlign: 'left' }}>E-Mail</th>
                      <th style={{ padding: '0.5rem', textAlign: 'left' }}>Team</th>
                      <th style={{ padding: '0.5rem', textAlign: 'center' }}>Einsätze</th>
                    </tr>
                  </thead>
                  <tbody>
                    {archivedUsers.map(u => (
                      <tr key={u.id} style={{ borderBottom: '1px solid #eee', backgroundColor: selectedUsers.includes(u.id) ? '#fff3e0' : 'transparent' }}>
                        <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                          <input
                            type="checkbox"
                            checked={selectedUsers.includes(u.id)}
                            onChange={() => toggleUserSelection(u.id)}
                          />
                        </td>
                        <td style={{ padding: '0.5rem' }}>
                          {u.first_name || u.last_name ? `${u.first_name || ''} ${u.last_name || ''}`.trim() : '-'}
                        </td>
                        <td style={{ padding: '0.5rem' }}>{u.email}</td>
                        <td style={{ padding: '0.5rem' }}>
                          {u.team ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
                              {u.team.split(/[,;]\s*/).map((t, idx) => {
                                const trimmed = t.trim();
                                if (!trimmed) return null;
                                const color = getTagColor(trimmed);
                                return (
                                  <span key={idx} style={{
                                    padding: '0.1rem 0.4rem',
                                    borderRadius: '10px',
                                    fontSize: '0.75rem',
                                    backgroundColor: color.bg,
                                    color: color.text
                                  }}>{trimmed}</span>
                                );
                              })}
                            </div>
                          ) : '-'}
                        </td>
                        <td style={{ padding: '0.5rem', textAlign: 'center' }}>{u.helping_events_count || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Events Archive Subtab */}
        {archivSubTab === 'events' && (
          <>
            <div className="card" style={{ marginBottom: '2rem' }}>
              <h3 style={{ margin: 0 }}>Vergangene Events ({archivedEvents.length})</h3>
            </div>

        {archivedEvents.length === 0 ? (
          <p style={{ color: '#666', textAlign: 'center' }}>Keine vergangenen Events vorhanden.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {archivedEvents.map((event) => {
              const totalHelpers = event.shifts?.reduce((sum, s) => sum + s.helpers_count, 0) || 0;
              const totalNeeded = event.shifts?.reduce((sum, s) => sum + s.helpers_needed, 0) || 0;
              const isExpanded = expandedArchiveEvent === event.id;

              const isEditing = editingEvent && editingEvent.id === event.id;

              return (
                <div key={event.id} className="card" style={{ backgroundColor: '#fafafa' }}>
                  {isEditing ? (
                    /* Edit Form for Archived Event */
                    <form onSubmit={handleUpdateEvent}>
                      <h3 style={{ marginBottom: '1rem' }}>Event bearbeiten</h3>
                      <label>Titel</label>
                      <input
                        type="text"
                        value={editingEvent.title}
                        onChange={(e) => setEditingEvent({...editingEvent, title: e.target.value})}
                        required
                      />
                      <label>Beschreibung</label>
                      <textarea
                        value={editingEvent.description}
                        onChange={(e) => setEditingEvent({...editingEvent, description: e.target.value})}
                        rows={3}
                      />
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                        <div>
                          <label>Datum</label>
                          <input
                            type="date"
                            value={editingEvent.date}
                            onChange={(e) => setEditingEvent({...editingEvent, date: e.target.value})}
                            required
                          />
                        </div>
                        <div>
                          <label>Ort</label>
                          <input
                            type="text"
                            value={editingEvent.location}
                            onChange={(e) => setEditingEvent({...editingEvent, location: e.target.value})}
                            required
                          />
                        </div>
                      </div>

                      <h4 style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>Einsätze</h4>
                      {editingEvent.shifts.map((shift, index) => (
                        <div key={index} style={{ padding: '1rem', backgroundColor: '#f5f5f5', marginBottom: '1rem', borderRadius: '4px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                            <strong>Einsatz {index + 1}</strong>
                            {editingEvent.shifts.length > 1 && (
                              <button type="button" onClick={() => removeEditShift(index)} style={{ color: '#C62828', background: 'none', border: 'none', cursor: 'pointer' }}>
                                Entfernen
                              </button>
                            )}
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
                            <input
                              type="text"
                              placeholder="Name"
                              value={shift.name}
                              onChange={(e) => updateEditShift(index, 'name', e.target.value)}
                              required
                            />
                            <input
                              type="time"
                              value={shift.start_time}
                              onChange={(e) => updateEditShift(index, 'start_time', e.target.value)}
                              required
                            />
                            <input
                              type="number"
                              placeholder="Dauer (Min.)"
                              value={shift.duration_minutes}
                              onChange={(e) => updateEditShift(index, 'duration_minutes', e.target.value)}
                              required
                            />
                            <input
                              type="number"
                              placeholder="Helfer benötigt"
                              value={shift.helpers_needed}
                              onChange={(e) => updateEditShift(index, 'helpers_needed', e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      ))}
                      <button type="button" onClick={addEditShift} className="btn btn-secondary" style={{ marginBottom: '1rem' }}>
                        + Einsatz hinzufügen
                      </button>

                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button type="submit" className="btn">Speichern</button>
                        <button type="button" className="btn btn-secondary" onClick={() => setEditingEvent(null)}>Abbrechen</button>
                      </div>
                    </form>
                  ) : (
                    /* Display Mode */
                    <>
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => setExpandedArchiveEvent(isExpanded ? null : event.id)}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <strong>{event.title}</strong>
                            <div style={{ color: '#666', fontSize: '0.9rem', marginTop: '0.25rem' }}>
                              {formatDate(event.date)} • {event.location}
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            <span style={{
                              padding: '0.25rem 0.75rem',
                              backgroundColor: totalHelpers >= totalNeeded ? '#e8f5e9' : '#ffebee',
                              color: totalHelpers >= totalNeeded ? '#2e7d32' : '#c62828',
                              borderRadius: '4px',
                              fontSize: '0.9rem',
                              fontWeight: 'bold'
                            }}>
                              {totalHelpers}/{totalNeeded} Helfer
                            </span>
                            <span style={{ color: '#666' }}>{isExpanded ? '▲' : '▼'}</span>
                          </div>
                        </div>
                      </div>

                      {isExpanded && (
                        <div style={{ marginTop: '1rem', borderTop: '1px solid #e0e0e0', paddingTop: '1rem' }}>
                          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
                            <button
                              className="btn"
                              onClick={(e) => { e.stopPropagation(); startEditArchivedEvent(event); }}
                              style={{ padding: '0.5rem 1rem' }}
                            >
                              Bearbeiten
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={(e) => { e.stopPropagation(); handleDeleteArchivedEvent(event.id); }}
                              style={{ padding: '0.5rem 1rem' }}
                            >
                              Löschen
                            </button>
                          </div>

                      {event.description && (
                        <p style={{ color: '#555', marginBottom: '1rem', whiteSpace: 'pre-line', fontSize: '0.9rem' }}>
                          {event.description}
                        </p>
                      )}

                      <h4 style={{ marginBottom: '0.75rem', color: '#666' }}>Einsätze</h4>
                      {event.shifts && event.shifts.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                          {event.shifts.map((shift) => (
                            <div key={shift.id} style={{
                              padding: '0.75rem',
                              backgroundColor: '#fff',
                              borderRadius: '4px',
                              border: '1px solid #e0e0e0'
                            }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                                <strong>{shift.name}</strong>
                                <span style={{
                                  padding: '0.25rem 0.5rem',
                                  backgroundColor: shift.helpers_count >= shift.helpers_needed ? '#e8f5e9' : '#fff3e0',
                                  borderRadius: '4px',
                                  fontSize: '0.85rem'
                                }}>
                                  {shift.helpers_count}/{shift.helpers_needed}
                                </span>
                              </div>
                              <div style={{ color: '#666', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
                                {shift.start_time} Uhr • {shift.duration_minutes} Min.
                              </div>
                              {shift.tags && (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem', marginBottom: '0.5rem' }}>
                                  {shift.tags.split(/;\s*/).map((tag, idx) => {
                                    const trimmedTag = tag.trim();
                                    if (!trimmedTag) return null;
                                    const color = getTagColor(trimmedTag);
                                    return (
                                      <span key={idx} style={{
                                        display: 'inline-block',
                                        padding: '0.15rem 0.5rem',
                                        borderRadius: '12px',
                                        fontSize: '0.7rem',
                                        fontWeight: '500',
                                        backgroundColor: color.bg,
                                        color: color.text,
                                        whiteSpace: 'nowrap'
                                      }}>
                                        {trimmedTag}
                                      </span>
                                    );
                                  })}
                                </div>
                              )}
                              <div style={{ fontSize: '0.85rem' }}>
                                <div style={{ color: '#666', marginBottom: '0.5rem' }}>Helfer:</div>
                                {shift.helpers && shift.helpers.length > 0 ? (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', marginBottom: '0.5rem' }}>
                                    {shift.helpers.map((h) => (
                                      <div key={h.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#e8f5e9', padding: '0.25rem 0.5rem', borderRadius: '4px' }}>
                                        <span>
                                          {h.first_name || h.last_name
                                            ? `${h.first_name || ''} ${h.last_name || ''}`.trim()
                                            : h.email}
                                        </span>
                                        <button
                                          onClick={(e) => { e.stopPropagation(); handleRemoveHelperFromShift(shift.id, h.id); }}
                                          style={{ background: 'none', border: 'none', color: '#c62828', cursor: 'pointer', fontSize: '0.8rem', padding: '0 0.25rem' }}
                                          title="Helfer entfernen"
                                        >
                                          ✕
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div style={{ color: '#999', fontSize: '0.85rem', fontStyle: 'italic', marginBottom: '0.5rem' }}>
                                    Keine Helfer
                                  </div>
                                )}
                                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                                  <select
                                    id={`add-helper-${shift.id}`}
                                    style={{ flex: 1, padding: '0.25rem', fontSize: '0.85rem', borderRadius: '4px', border: '1px solid #ddd' }}
                                    defaultValue=""
                                  >
                                    <option value="" disabled>Helfer hinzufügen...</option>
                                    {users
                                      .filter(u => !shift.helpers?.some(h => h.id === u.id))
                                      .map(u => (
                                        <option key={u.id} value={u.id}>
                                          {u.first_name || u.last_name
                                            ? `${u.first_name || ''} ${u.last_name || ''}`.trim()
                                            : u.email}
                                        </option>
                                      ))
                                    }
                                  </select>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const select = document.getElementById(`add-helper-${shift.id}`);
                                      if (select.value) {
                                        handleAddHelperToShift(shift.id, parseInt(select.value));
                                        select.value = '';
                                      }
                                    }}
                                    className="btn"
                                    style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p style={{ color: '#999' }}>Keine Einsätze definiert</p>
                      )}
                    </div>
                  )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        )}
          </>
        )}
      </>
    );
  };

  const renderLogs = () => {
    const formatLogDetails = (log) => {
      if (!log.details) return null;
      const details = log.details;

      switch (log.action) {
        case 'shift_signup':
        case 'shift_signout':
          return (
            <span>
              {details.event_title} → {details.shift_name}
              {details.by_admin && details.target_user_email !== log.user_email && (
                <span style={{ color: '#666' }}> (für {details.target_user_email})</span>
              )}
            </span>
          );
        case 'event_created':
        case 'event_updated':
        case 'event_deleted':
          return <span>{details.title} ({details.date})</span>;
        case 'user_deleted':
          return <span>{details.email}</span>;
        case 'user_admin_changed':
          return (
            <span>
              {details.email}: {details.old_is_admin ? 'Admin' : 'User'} → {details.new_is_admin ? 'Admin' : 'User'}
            </span>
          );
        case 'user_team_admin_changed':
          return (
            <span>
              {details.email}: {details.old_is_team_admin ? 'Team Admin' : 'User'} → {details.new_is_team_admin ? 'Team Admin' : 'User'}
            </span>
          );
        case 'users_imported':
          return <span>{details.source}: {details.created} erstellt, {details.updated || 0} aktualisiert</span>;
        case 'events_imported':
          return <span>{details.source}: {details.count} Events importiert</span>;
        case 'sms_sent':
          return (
            <span>
              {details.type === 'test' ? 'Test-SMS' : details.type === 'reminder' ? 'Erinnerung' : 'SMS'} an {details.to}
              {details.event && <span style={{ color: '#666' }}> ({details.event})</span>}
              {details.status === 'success' ? (
                <span style={{ color: '#4CAF50', marginLeft: '0.5rem' }}>✓</span>
              ) : (
                <span style={{ color: '#f44336', marginLeft: '0.5rem' }}>✗ {details.error_message}</span>
              )}
            </span>
          );
        default:
          return <span>{JSON.stringify(details)}</span>;
      }
    };

    const formatDate = (isoString) => {
      const date = new Date(isoString);
      return date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    return (
      <>
        <h3>Aktivitätsprotokoll</h3>

        {/* Search and Filter Form */}
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <form onSubmit={handleLogSearch}>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
              <div style={{ flex: '1', minWidth: '200px' }}>
                <label style={{ fontSize: '0.85rem', color: '#666' }}>Suche</label>
                <input
                  type="text"
                  placeholder="E-Mail oder Details durchsuchen..."
                  value={logSearch}
                  onChange={(e) => setLogSearch(e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
              <div style={{ minWidth: '180px' }}>
                <label style={{ fontSize: '0.85rem', color: '#666' }}>Ereignistyp</label>
                <select
                  value={logFilter}
                  onChange={(e) => setLogFilter(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd' }}
                >
                  <option value="">Alle Ereignisse</option>
                  {Object.entries(logActions).map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))}
                </select>
              </div>
              <div style={{ minWidth: '140px' }}>
                <label style={{ fontSize: '0.85rem', color: '#666' }}>Von Datum</label>
                <input
                  type="date"
                  value={logDateFrom}
                  onChange={(e) => setLogDateFrom(e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
              <div style={{ minWidth: '140px' }}>
                <label style={{ fontSize: '0.85rem', color: '#666' }}>Bis Datum</label>
                <input
                  type="date"
                  value={logDateTo}
                  onChange={(e) => setLogDateTo(e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button type="submit" className="btn" style={{ padding: '0.5rem 1rem' }}>
                  Suchen
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleLogReset}
                  style={{ padding: '0.5rem 1rem' }}
                >
                  Zurücksetzen
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* Results info */}
        <div style={{ marginBottom: '1rem', color: '#666' }}>
          {logTotal} Einträge gefunden {logPages > 1 && `(Seite ${logPage} von ${logPages})`}
        </div>

        {/* Log entries */}
        {loading ? (
          <p>Lädt...</p>
        ) : activityLogs.length === 0 ? (
          <p style={{ color: '#999' }}>Keine Aktivitäten gefunden</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {activityLogs.map((log) => (
              <div
                key={log.id}
                className="card"
                style={{
                  padding: '0.75rem 1rem',
                  backgroundColor: '#fafafa',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '0.5rem 1rem',
                  alignItems: 'center'
                }}
              >
                <span style={{
                  backgroundColor: getLogActionColor(log.action),
                  color: 'white',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '4px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  minWidth: '120px',
                  textAlign: 'center'
                }}>
                  {log.action_label}
                </span>
                <span style={{ fontWeight: 'bold', minWidth: '200px' }}>
                  {log.user_email || 'System'}
                </span>
                <span style={{ flex: 1, color: '#555' }}>
                  {formatLogDetails(log)}
                </span>
                <span style={{ color: '#999', fontSize: '0.85rem', whiteSpace: 'nowrap' }}>
                  {formatDate(log.created_at)}
                </span>
              </div>
            ))}
          </div>
        )}

        {/* Pagination */}
        {logPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginTop: '1.5rem' }}>
            <button
              className="btn btn-secondary"
              onClick={() => loadActivityLogs(logPage - 1)}
              disabled={logPage <= 1}
              style={{ padding: '0.5rem 1rem' }}
            >
              ← Zurück
            </button>
            <span style={{ padding: '0.5rem 1rem', color: '#666' }}>
              Seite {logPage} von {logPages}
            </span>
            <button
              className="btn btn-secondary"
              onClick={() => loadActivityLogs(logPage + 1)}
              disabled={logPage >= logPages}
              style={{ padding: '0.5rem 1rem' }}
            >
              Weiter →
            </button>
          </div>
        )}
      </>
    );
  };

  const getLogActionColor = (action) => {
    const colors = {
      'login': '#2196F3',
      'event_created': '#4CAF50',
      'event_updated': '#FF9800',
      'event_deleted': '#f44336',
      'shift_signup': '#4CAF50',
      'shift_signout': '#FF9800',
      'user_created': '#2196F3',
      'user_deleted': '#f44336',
      'user_admin_changed': '#9C27B0',
      'users_imported': '#2196F3',
      'events_imported': '#4CAF50',
      'sms_sent': '#9C27B0'
    };
    return colors[action] || '#666';
  };

  return (
    <div>
      <h2 style={{ marginBottom: '1rem' }}>Admin-Bereich</h2>

      {/* Tab Navigation */}
      <div style={{
        display: 'flex',
        gap: '0.5rem',
        borderBottom: '2px solid #e0e0e0',
        marginBottom: '2rem',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => setActiveTab('events')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: activeTab === 'events' ? '#C62828' : 'transparent',
            color: activeTab === 'events' ? 'white' : '#666',
            borderBottom: activeTab === 'events' ? '2px solid #C62828' : 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'events' ? 'bold' : 'normal',
            fontSize: '1rem',
            transition: 'all 0.2s'
          }}
        >
          Events
        </button>
        <button
          onClick={() => setActiveTab('templates')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: activeTab === 'templates' ? '#C62828' : 'transparent',
            color: activeTab === 'templates' ? 'white' : '#666',
            borderBottom: activeTab === 'templates' ? '2px solid #C62828' : 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'templates' ? 'bold' : 'normal',
            fontSize: '1rem',
            transition: 'all 0.2s'
          }}
        >
          Vorlagen
        </button>
        <button
          onClick={() => setActiveTab('users')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: activeTab === 'users' ? '#C62828' : 'transparent',
            color: activeTab === 'users' ? 'white' : '#666',
            borderBottom: activeTab === 'users' ? '2px solid #C62828' : 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'users' ? 'bold' : 'normal',
            fontSize: '1rem',
            transition: 'all 0.2s'
          }}
        >
          Benutzer
        </button>
        <button
          onClick={() => setActiveTab('connections')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: activeTab === 'connections' ? '#C62828' : 'transparent',
            color: activeTab === 'connections' ? 'white' : '#666',
            borderBottom: activeTab === 'connections' ? '2px solid #C62828' : 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'connections' ? 'bold' : 'normal',
            fontSize: '1rem',
            transition: 'all 0.2s'
          }}
        >
          Einstellungen
        </button>
        <button
          onClick={() => setActiveTab('statistik')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: activeTab === 'statistik' ? '#C62828' : 'transparent',
            color: activeTab === 'statistik' ? 'white' : '#666',
            borderBottom: activeTab === 'statistik' ? '2px solid #C62828' : 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'statistik' ? 'bold' : 'normal',
            fontSize: '1rem',
            transition: 'all 0.2s'
          }}
        >
          Statistik
        </button>
        <button
          onClick={() => setActiveTab('archiv')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: activeTab === 'archiv' ? '#C62828' : 'transparent',
            color: activeTab === 'archiv' ? 'white' : '#666',
            borderBottom: activeTab === 'archiv' ? '2px solid #C62828' : 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'archiv' ? 'bold' : 'normal',
            fontSize: '1rem',
            transition: 'all 0.2s'
          }}
        >
          Archiv
        </button>
        <button
          onClick={() => setActiveTab('log')}
          style={{
            padding: '0.75rem 1.5rem',
            border: 'none',
            background: activeTab === 'log' ? '#C62828' : 'transparent',
            color: activeTab === 'log' ? 'white' : '#666',
            borderBottom: activeTab === 'log' ? '2px solid #C62828' : 'none',
            cursor: 'pointer',
            fontWeight: activeTab === 'log' ? 'bold' : 'normal',
            fontSize: '1rem',
            transition: 'all 0.2s'
          }}
        >
          Log
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'events' && renderEvents()}
      {activeTab === 'templates' && renderTemplates()}
      {activeTab === 'users' && renderUsers()}
      {activeTab === 'connections' && renderConnections()}
      {activeTab === 'statistik' && renderStatistik()}
      {activeTab === 'archiv' && renderArchiv()}
      {activeTab === 'log' && renderLogs()}
    </div>
  );
}

export default Admin;
